import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions, QueryFunctionContext } from 'react-query';
import { gqlRequest } from 'lib/graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Coordinates: any;
  DateTime: any;
  JSON: any;
  Void: any;
};

export type AlgoResult = {
  name: Scalars['String'];
  pisteId: Scalars['String'];
  rating?: Maybe<Scalars['Int']>;
  score: Scalars['Float'];
};

export type Article = {
  _id?: Maybe<Scalars['ID']>;
  chapo?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  coverPicture?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  excerpt?: Maybe<Scalars['String']>;
  metaDescription?: Maybe<Scalars['String']>;
  metaTitle?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  subtag?: Maybe<Scalars['String']>;
  tag?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
};

export type ArticleQueryInput = {
  subtags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type BacProActivite = {
  activiteId?: Maybe<Scalars['ID']>;
  status?: Maybe<Scalars['String']>;
};

export type BilanModule = {
  moduleId?: Maybe<Scalars['ID']>;
  questions?: Maybe<Array<Maybe<BilanModuleQuestion>>>;
};

export type BilanModuleQuestion = {
  answer?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
};

export type BilanModuleQuestionInput = {
  answer?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
};

export type CentresDinterets = {
  autre?: Maybe<Scalars['String']>;
  centresDinterets: Array<Maybe<Scalars['String']>>;
  danse?: Maybe<Scalars['String']>;
  sport?: Maybe<Scalars['String']>;
};

export type CentresDinteretsInput = {
  autre?: InputMaybe<Scalars['String']>;
  centresDinterets: Array<InputMaybe<Scalars['String']>>;
  danse?: InputMaybe<Scalars['String']>;
  sport?: InputMaybe<Scalars['String']>;
};

export type CheckCredentials = {
  success?: Maybe<Scalars['Boolean']>;
};

export type Classe = {
  _id?: Maybe<Scalars['ID']>;
  activitiesCounter?: Maybe<Scalars['Int']>;
  anneeScolaire?: Maybe<Scalars['Int']>;
  classeName?: Maybe<Scalars['String']>;
  cvdesignrGroupId?: Maybe<Scalars['ID']>;
  departement?: Maybe<Scalars['String']>;
  /** Elèves de la classe */
  eleves?: Maybe<Array<Maybe<User>>>;
  elevesCounter?: Maybe<Scalars['Int']>;
  elevesIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  familleMetiers?: Maybe<Scalars['String']>;
  filiere?: Maybe<Scalars['String']>;
  filiereBacPro?: Maybe<Scalars['String']>;
  filiereTechno?: Maybe<Scalars['String']>;
  /** Lycée de la classe */
  lycee?: Maybe<Lycee>;
  lyceeEtrangerName?: Maybe<Scalars['String']>;
  lyceeId?: Maybe<Scalars['String']>;
  modules?: Maybe<Array<Maybe<ModuleConf>>>;
  modulesCounter?: Maybe<Scalars['Int']>;
  niveau?: Maybe<Scalars['String']>;
  pays?: Maybe<Scalars['String']>;
  /** Profs de la classe */
  profs?: Maybe<Array<Maybe<User>>>;
  signupToken?: Maybe<Scalars['String']>;
};

export type ClasseInput = {
  classeName?: InputMaybe<Scalars['String']>;
  departement?: InputMaybe<Scalars['String']>;
  familleMetiers?: InputMaybe<Scalars['String']>;
  filiere?: InputMaybe<Scalars['String']>;
  filiereBacPro?: InputMaybe<Scalars['String']>;
  filiereTechno?: InputMaybe<Scalars['String']>;
  lyceeEtrangerName?: InputMaybe<Scalars['String']>;
  lyceeId?: InputMaybe<Scalars['String']>;
  niveau?: InputMaybe<Scalars['String']>;
  pays?: InputMaybe<Scalars['String']>;
};

export type ContactInfo = {
  _id?: Maybe<Scalars['ID']>;
  age?: Maybe<Scalars['Int']>;
  birthDate?: Maybe<Scalars['DateTime']>;
  filiere?: Maybe<Scalars['String']>;
  filiereBacPro?: Maybe<Scalars['String']>;
  filiereTechno?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  niveau?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  pisteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  pistes?: Maybe<Array<Maybe<Piste>>>;
  role?: Maybe<Scalars['String']>;
};

export type ContactRequest = {
  _id?: Maybe<Scalars['ID']>;
  contactInfo?: Maybe<ContactInfo>;
  exchangeStats?: Maybe<ExchangeStats>;
  hasNewMessage?: Maybe<Scalars['Boolean']>;
  hasSentIntroMessage?: Maybe<Scalars['Boolean']>;
  problemEclaireur?: Maybe<Scalars['String']>;
  problemLyceen?: Maybe<Scalars['String']>;
  requestBy?: Maybe<Scalars['String']>;
  requestFor?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CvdesignrFlowResponse = {
  kind: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type Domain = {
  domain?: Maybe<Scalars['String']>;
  interest?: Maybe<Scalars['Int']>;
};

export type DomainInput = {
  domain?: InputMaybe<Scalars['String']>;
  interest?: InputMaybe<Scalars['Int']>;
};

export type EclaireurQueryInput = {
  experiences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filieres?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  isBoursierLycee?: InputMaybe<Scalars['Boolean']>;
  pisteId?: InputMaybe<Scalars['String']>;
  regions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  showFavorites?: InputMaybe<Scalars['Boolean']>;
  typesFormation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EclaireurQuestionsInput = {
  accomodation?: InputMaybe<Scalars['String']>;
  ambiance?: InputMaybe<Scalars['String']>;
  groupe?: InputMaybe<Scalars['String']>;
  hardTimes?: InputMaybe<Scalars['String']>;
  moments?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Scalars['String']>;
  positif?: InputMaybe<Scalars['String']>;
};

export type Environnement = {
  interest: Scalars['Int'];
  type: Scalars['String'];
};

export type EnvironnementInput = {
  interest: Scalars['Int'];
  type: Scalars['String'];
};

export type Etablissement = {
  _id: Scalars['ID'];
  commune?: Maybe<Scalars['String']>;
  departement?: Maybe<Scalars['String']>;
  idEtablissementOnisep?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  universite?: Maybe<Scalars['String']>;
};

export type ExchangeStats = {
  firstEclaireurMessage?: Maybe<Scalars['DateTime']>;
  firstLyceenMessage?: Maybe<Scalars['DateTime']>;
  gotResponse?: Maybe<Scalars['Boolean']>;
  lastEclaireurMessage?: Maybe<Scalars['DateTime']>;
  lastMessageDate?: Maybe<Scalars['DateTime']>;
  numberOfMessages?: Maybe<Scalars['Int']>;
  responseDelay?: Maybe<Scalars['Float']>;
};

export type FaqItem = {
  _id: Scalars['ID'];
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type FavoriteEclaireur = {
  _id: Scalars['String'];
};

export type FavoriteEclaireurInput = {
  _id: Scalars['String'];
};

export type FavoritePiste = {
  id: Scalars['String'];
};

export type FavoritePisteInput = {
  id: Scalars['String'];
};

export type Formation = {
  _id: Scalars['ID'];
  idEtablissementOnisep?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type FormationComparaisons = {
  correspond?: Maybe<Scalars['String']>;
  correspondpas?: Maybe<Scalars['String']>;
  cout?: Maybe<Scalars['String']>;
  debouches?: Maybe<Scalars['String']>;
  duree?: Maybe<Scalars['String']>;
  experiencePro?: Maybe<Array<Maybe<Scalars['String']>>>;
  order?: Maybe<Scalars['Int']>;
  pisteId: Scalars['String'];
};

export type FormationComparaisonsInput = {
  correspond?: InputMaybe<Scalars['String']>;
  correspondpas?: InputMaybe<Scalars['String']>;
  cout?: InputMaybe<Scalars['String']>;
  debouches?: InputMaybe<Scalars['String']>;
  duree?: InputMaybe<Scalars['String']>;
  experiencePro?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  order?: InputMaybe<Scalars['Int']>;
  pisteId: Scalars['String'];
};

export type GeoJson = {
  coordinates?: Maybe<Scalars['Coordinates']>;
  type: Scalars['String'];
};

export type GitInfo = {
  message?: Maybe<Scalars['String']>;
  sha?: Maybe<Scalars['ID']>;
};

export type HashedPassword = {
  algorithm: Scalars['String'];
  digest: Scalars['String'];
};

export type IntAnswerField = {
  key: Scalars['String'];
  value?: Maybe<Scalars['Int']>;
};

export type IntAnswerFieldInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['Int']>;
};

export type LoginMethodResponse = {
  id: Scalars['String'];
  ssoId: Scalars['String'];
  token: Scalars['String'];
  tokenExpires: Scalars['Float'];
  user?: Maybe<User>;
};

export type Lycee = {
  _id: Scalars['ID'];
  academie?: Maybe<Scalars['String']>;
  departement: Scalars['String'];
  departementCode: Scalars['String'];
  isPrioritaire?: Maybe<Scalars['Boolean']>;
  location?: Maybe<GeoJson>;
  nom: Scalars['String'];
  uai_ips?: Maybe<Scalars['String']>;
  ville: Scalars['String'];
};

export type Matiere = {
  grade?: Maybe<Scalars['Float']>;
  like?: Maybe<Scalars['Int']>;
  matiere?: Maybe<Scalars['String']>;
};

export type MatiereInput = {
  grade?: InputMaybe<Scalars['Float']>;
  isSpe?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['Int']>;
  matiere?: InputMaybe<Scalars['String']>;
};

export type Media = {
  email?: Maybe<Scalars['Boolean']>;
  onsite?: Maybe<Scalars['Boolean']>;
  sms?: Maybe<Scalars['Boolean']>;
};

export type MediaInput = {
  email?: InputMaybe<Scalars['Boolean']>;
  onsite?: InputMaybe<Scalars['Boolean']>;
  sms?: InputMaybe<Scalars['Boolean']>;
};

export type Message = {
  _id: Scalars['ID'];
  content: Scalars['String'];
  introQuestionCategory?: Maybe<Scalars['String']>;
  introQuestionKey?: Maybe<Scalars['String']>;
  recipients: Array<Maybe<Scalars['String']>>;
  sender: Scalars['String'];
  threadId: Scalars['String'];
  timestamp: Scalars['Float'];
  type?: Maybe<Scalars['String']>;
};

export type MetierOuSecteurReve = {
  metierOuSecteur?: Maybe<Scalars['String']>;
  pourraitInteresser?: Maybe<Array<Maybe<Scalars['String']>>>;
  saitMetierOuSecteur: Scalars['Boolean'];
};

export type MetierOuSecteurReveInput = {
  metierOuSecteur?: InputMaybe<Scalars['String']>;
  pourraitInteresser?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  saitMetierOuSecteur: Scalars['Boolean'];
};

export type ModuleConf = {
  disabled?: Maybe<Scalars['Boolean']>;
  disabledActivites?: Maybe<Array<Maybe<Scalars['String']>>>;
  moduleId: Scalars['String'];
};

export type ModuleConfigInput = {
  disabled?: InputMaybe<Scalars['Boolean']>;
  disabledActivites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moduleId: Scalars['String'];
};

export type Mutation = {
  addProf?: Maybe<Scalars['Void']>;
  changeCurrentClasse?: Maybe<Scalars['Void']>;
  changePassword?: Maybe<SuccessResponse>;
  countLyceenAlgo?: Maybe<Scalars['Void']>;
  createClasse?: Maybe<Scalars['ID']>;
  createContactRequest?: Maybe<Scalars['ID']>;
  createCvdesignrUser?: Maybe<Scalars['String']>;
  createEclaireur?: Maybe<LoginMethodResponse>;
  createLyceen?: Maybe<LoginMethodResponse>;
  createLyceenHorsScope?: Maybe<Scalars['Void']>;
  createProf?: Maybe<LoginMethodResponse>;
  createUserSsoRegistered?: Maybe<LoginMethodResponse>;
  deleteClasse?: Maybe<Scalars['Void']>;
  deleteHorsScopeUser?: Maybe<Scalars['Void']>;
  deleteMyAccount?: Maybe<Scalars['Int']>;
  devenirEclaireur?: Maybe<Scalars['Void']>;
  forgotPassword?: Maybe<SuccessResponse>;
  generateToken?: Maybe<Scalars['Void']>;
  importEleves?: Maybe<Scalars['Void']>;
  jobreadyToken?: Maybe<Scalars['String']>;
  joinClasse?: Maybe<Scalars['Void']>;
  loginToRefreshSession?: Maybe<LoginMethodResponse>;
  loginWithSso?: Maybe<LoginMethodResponse>;
  logout?: Maybe<SuccessResponse>;
  markThreadAsSeen?: Maybe<Scalars['Void']>;
  quitClasse?: Maybe<Scalars['Void']>;
  rateAlgoResult?: Maybe<Scalars['Void']>;
  removeEleveFromClasse?: Maybe<Scalars['Boolean']>;
  removeProf?: Maybe<Scalars['Void']>;
  resendVerificationEmail?: Maybe<SuccessResponse>;
  resetDemo?: Maybe<Scalars['Void']>;
  resetPassword?: Maybe<LoginMethodResponse>;
  sendMessage?: Maybe<Scalars['Void']>;
  setActiviteBacPro?: Maybe<Scalars['Void']>;
  setBilanModule?: Maybe<Scalars['Void']>;
  setEclaireurMobiliteGroup?: Maybe<Scalars['Void']>;
  setLyceeStudyYear?: Maybe<Scalars['Void']>;
  setMyProfile?: Maybe<Scalars['Void']>;
  setPhoneNumber?: Maybe<Scalars['Void']>;
  setStateOfMind?: Maybe<Scalars['Void']>;
  setStudyYear?: Maybe<Scalars['Void']>;
  signalProblem?: Maybe<Scalars['Void']>;
  submitPisteFeedback?: Maybe<Scalars['ID']>;
  triggerAlgo?: Maybe<Scalars['Void']>;
  updateClasse?: Maybe<Scalars['Void']>;
  updateModule?: Maybe<Classe>;
  verifyEmail?: Maybe<LoginMethodResponse>;
};


export type MutationAddProfArgs = {
  classeId: Scalars['ID'];
  profId: Scalars['ID'];
};


export type MutationChangeCurrentClasseArgs = {
  id: Scalars['ID'];
};


export type MutationChangePasswordArgs = {
  newPassword: HashedPassword;
  oldPassword: HashedPassword;
};


export type MutationCountLyceenAlgoArgs = {
  lyceenAlgoCounter: Scalars['String'];
};


export type MutationCreateClasseArgs = {
  input: ClasseInput;
};


export type MutationCreateContactRequestArgs = {
  group?: InputMaybe<Scalars['String']>;
  requestFor?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateCvdesignrUserArgs = {
  cvdesignrPassword: Scalars['String'];
};


export type MutationCreateEclaireurArgs = {
  profile: UserProfileInput;
};


export type MutationCreateLyceenArgs = {
  profile: UserProfileInput;
  signupToken?: InputMaybe<Scalars['String']>;
};


export type MutationCreateLyceenHorsScopeArgs = {
  niveau: Scalars['String'];
};


export type MutationCreateProfArgs = {
  profile: UserProfileInput;
};


export type MutationCreateUserSsoRegisteredArgs = {
  ssoProfileToken: Scalars['String'];
};


export type MutationDeleteClasseArgs = {
  id: Scalars['ID'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String'];
};


export type MutationGenerateTokenArgs = {
  classeId: Scalars['ID'];
};


export type MutationImportElevesArgs = {
  classeId: Scalars['ID'];
  eleveIds: Array<Scalars['ID']>;
};


export type MutationJoinClasseArgs = {
  token: Scalars['String'];
};


export type MutationLoginToRefreshSessionArgs = {
  ssoId: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationLoginWithSsoArgs = {
  ssoProfileToken: Scalars['String'];
};


export type MutationLogoutArgs = {
  token: Scalars['String'];
};


export type MutationMarkThreadAsSeenArgs = {
  threadId: Scalars['String'];
};


export type MutationQuitClasseArgs = {
  id: Scalars['ID'];
};


export type MutationRateAlgoResultArgs = {
  pisteId: Scalars['ID'];
  rating: Scalars['Int'];
};


export type MutationRemoveEleveFromClasseArgs = {
  classeId: Scalars['ID'];
  eleveId: Scalars['ID'];
};


export type MutationRemoveProfArgs = {
  classeId: Scalars['ID'];
  profId: Scalars['ID'];
};


export type MutationResetPasswordArgs = {
  newPassword: HashedPassword;
  token: Scalars['String'];
};


export type MutationSendMessageArgs = {
  content: Scalars['String'];
  introQuestionCategory?: InputMaybe<Scalars['String']>;
  introQuestionKey?: InputMaybe<Scalars['String']>;
  threadId: Scalars['String'];
};


export type MutationSetActiviteBacProArgs = {
  activiteId: Scalars['ID'];
  moduleActivites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status: Scalars['String'];
};


export type MutationSetBilanModuleArgs = {
  moduleId: Scalars['ID'];
  questions: Array<InputMaybe<BilanModuleQuestionInput>>;
};


export type MutationSetEclaireurMobiliteGroupArgs = {
  hasBeenClicked: Scalars['Boolean'];
};


export type MutationSetLyceeStudyYearArgs = {
  filiere?: InputMaybe<Scalars['String']>;
  filiereBacPro?: InputMaybe<Scalars['String']>;
  filiereTechno?: InputMaybe<Scalars['String']>;
  niveau: Scalars['String'];
};


export type MutationSetMyProfileArgs = {
  input: UserProfileInput;
};


export type MutationSetPhoneNumberArgs = {
  numberToVerify: Scalars['String'];
  tokenToVerify?: InputMaybe<Scalars['String']>;
};


export type MutationSetStateOfMindArgs = {
  input: StateOfMindInput;
};


export type MutationSetStudyYearArgs = {
  studyYear: StudyYearInput;
};


export type MutationSignalProblemArgs = {
  problem: Scalars['String'];
  threadId: Scalars['String'];
};


export type MutationSubmitPisteFeedbackArgs = {
  input: PisteFeedbackInput;
};


export type MutationTriggerAlgoArgs = {
  classeHasModules: Scalars['Boolean'];
};


export type MutationUpdateClasseArgs = {
  classeId: Scalars['String'];
  input: ClasseInput;
};


export type MutationUpdateModuleArgs = {
  classeId: Scalars['String'];
  moduleConfig: ModuleConfigInput;
};


export type MutationVerifyEmailArgs = {
  token: Scalars['String'];
};

export type Notifications = {
  media?: Maybe<Media>;
};

export type NotificationsInput = {
  media?: InputMaybe<MediaInput>;
};

export type PhoneNumber = {
  number?: Maybe<Scalars['String']>;
  verified?: Maybe<Scalars['Boolean']>;
};

export type Piste = {
  _id?: Maybe<Scalars['ID']>;
  bacs?: Maybe<Array<Maybe<Scalars['String']>>>;
  chapo?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  contentBacPro?: Maybe<Scalars['String']>;
  coverPicture?: Maybe<Scalars['String']>;
  disponibleEnApprentissage?: Maybe<Scalars['Boolean']>;
  duree?: Maybe<Scalars['String']>;
  dureeStageFrom?: Maybe<Scalars['Int']>;
  dureeStageTo?: Maybe<Scalars['Int']>;
  isInsertionPro?: Maybe<Scalars['Boolean']>;
  metaDescription?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  pisteFeedback?: Maybe<PisteFeedback>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  typeEnseignement?: Maybe<Scalars['String']>;
  typeEtablissement?: Maybe<Scalars['String']>;
  typeFormat?: Maybe<Scalars['String']>;
  typeFormation?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PisteFeedback = {
  hasFeedback?: Maybe<Scalars['Boolean']>;
  knewThePiste?: Maybe<Scalars['Boolean']>;
};

export type PisteFeedbackInput = {
  consideredThePiste?: InputMaybe<Scalars['Boolean']>;
  knewThePiste: Scalars['Boolean'];
  pisteId: Scalars['String'];
  pisteName: Scalars['String'];
};

export type PisteOpinion = {
  dislike?: Maybe<Scalars['String']>;
  like?: Maybe<Scalars['String']>;
  pisteId: Scalars['String'];
  pisteName: Scalars['String'];
};

export type PisteOpinionInput = {
  dislike?: InputMaybe<Scalars['String']>;
  like?: InputMaybe<Scalars['String']>;
  pisteId: Scalars['String'];
  pisteName: Scalars['String'];
};

export type Query = {
  allClasses: Array<Maybe<Classe>>;
  articles: Array<Maybe<Article>>;
  checkCredentials?: Maybe<CheckCredentials>;
  classeById?: Maybe<Classe>;
  classeByToken?: Maybe<Classe>;
  currentClasse?: Maybe<Classe>;
  cvdesignrFlow?: Maybe<CvdesignrFlowResponse>;
  eclaireur?: Maybe<User>;
  eclaireurs?: Maybe<Array<Maybe<User>>>;
  eleve?: Maybe<User>;
  etablissements: Array<Maybe<Etablissement>>;
  faqItems: Array<Maybe<FaqItem>>;
  formations: Array<Maybe<Formation>>;
  gitInfo?: Maybe<GitInfo>;
  isHorsScope?: Maybe<Scalars['Boolean']>;
  lycee?: Maybe<Lycee>;
  lycees: Array<Maybe<Lycee>>;
  messagesByThreadId?: Maybe<Array<Maybe<Message>>>;
  myContactRequests?: Maybe<Array<Maybe<ContactRequest>>>;
  myUser?: Maybe<User>;
  ok?: Maybe<Scalars['Boolean']>;
  piste?: Maybe<Piste>;
  pistes: Array<Maybe<Piste>>;
  profByEmail?: Maybe<User>;
  resources: Array<Maybe<Resource>>;
  throwCustomError?: Maybe<Scalars['Boolean']>;
  throwCustomErrorWithDisplayMessage?: Maybe<Scalars['Boolean']>;
  throwError?: Maybe<Scalars['Boolean']>;
  userBySSOId?: Maybe<User>;
};


export type QueryArticlesArgs = {
  chapo?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<ArticleQueryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  subtag?: InputMaybe<Scalars['String']>;
  tag?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};


export type QueryCheckCredentialsArgs = {
  apiKey: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
};


export type QueryClasseByIdArgs = {
  id: Scalars['ID'];
};


export type QueryClasseByTokenArgs = {
  signupToken: Scalars['String'];
};


export type QueryEclaireurArgs = {
  id: Scalars['ID'];
};


export type QueryEclaireursArgs = {
  filters?: InputMaybe<EclaireurQueryInput>;
  group?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
};


export type QueryEleveArgs = {
  id: Scalars['ID'];
};


export type QueryEtablissementsArgs = {
  departement: Scalars['String'];
};


export type QueryFormationsArgs = {
  onisepId: Scalars['String'];
};


export type QueryLyceeArgs = {
  dep?: InputMaybe<Scalars['String']>;
  hasIntervention?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryLyceesArgs = {
  codeUAI?: InputMaybe<Scalars['String']>;
  departement?: InputMaybe<Scalars['String']>;
  hasIntervention?: InputMaybe<Scalars['Boolean']>;
  isLyceePro?: InputMaybe<Scalars['Boolean']>;
};


export type QueryMessagesByThreadIdArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  threadId: Scalars['String'];
};


export type QueryMyContactRequestsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  threadId?: InputMaybe<Scalars['String']>;
};


export type QueryPisteArgs = {
  _id?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPistesArgs = {
  classeHasModules?: InputMaybe<Scalars['Boolean']>;
  domaines?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  filiere?: InputMaybe<Scalars['String']>;
  isApprentissage?: InputMaybe<Scalars['Boolean']>;
  isInsertionPro?: InputMaybe<Scalars['Boolean']>;
  typesFormation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryProfByEmailArgs = {
  email: Scalars['String'];
};


export type QueryUserBySsoIdArgs = {
  email?: InputMaybe<Scalars['String']>;
  ssoId: Scalars['String'];
};

export type Resource = {
  _id?: Maybe<Scalars['ID']>;
  category?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type SecondFormationField = {
  codePostal?: Maybe<Scalars['String']>;
  departement?: Maybe<Scalars['String']>;
  doubleDegree?: Maybe<Scalars['Boolean']>;
  etablissement?: Maybe<Scalars['String']>;
  etablissementId?: Maybe<Scalars['String']>;
  formation?: Maybe<Scalars['String']>;
  formationId?: Maybe<Scalars['String']>;
  formationYear?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
  pays?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
};

export type SecondFormationInput = {
  codePostal?: InputMaybe<Scalars['String']>;
  departement?: InputMaybe<Scalars['String']>;
  doubleDegree?: InputMaybe<Scalars['Boolean']>;
  etablissement?: InputMaybe<Scalars['String']>;
  etablissementId?: InputMaybe<Scalars['String']>;
  formation?: InputMaybe<Scalars['String']>;
  formationId?: InputMaybe<Scalars['String']>;
  formationYear?: InputMaybe<Scalars['Int']>;
  option?: InputMaybe<Scalars['String']>;
  pays?: InputMaybe<Scalars['String']>;
  ville?: InputMaybe<Scalars['String']>;
};

export type StateOfMind = {
  seLancerDansEtudesSup?: Maybe<Scalars['String']>;
  souhaiteAccompagnement?: Maybe<Scalars['Boolean']>;
};

export type StateOfMindInput = {
  seLancerDansEtudesSup?: InputMaybe<Scalars['String']>;
  souhaiteAccompagnement?: InputMaybe<Scalars['Boolean']>;
};

export type StringAnswerField = {
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type StringAnswerFieldInput = {
  key: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
};

export type StudyYear = {
  codePostal?: Maybe<Scalars['String']>;
  departement?: Maybe<Scalars['String']>;
  etablissement?: Maybe<Scalars['String']>;
  etablissementId?: Maybe<Scalars['String']>;
  formation?: Maybe<Scalars['String']>;
  formationId?: Maybe<Scalars['String']>;
  formationYear?: Maybe<Scalars['Int']>;
  option?: Maybe<Scalars['String']>;
  optionAutre?: Maybe<Scalars['String']>;
  optionMentionCMI?: Maybe<Scalars['String']>;
  pays?: Maybe<Scalars['String']>;
  secondFormation?: Maybe<SecondFormationField>;
  skippingYear?: Maybe<Scalars['Boolean']>;
  skippingYearOccupation?: Maybe<Array<Maybe<Scalars['String']>>>;
  skippingYearOther?: Maybe<Scalars['String']>;
  ville?: Maybe<Scalars['String']>;
  year?: Maybe<Scalars['Int']>;
};

export type StudyYearInput = {
  codePostal?: InputMaybe<Scalars['String']>;
  departement?: InputMaybe<Scalars['String']>;
  etablissement?: InputMaybe<Scalars['String']>;
  etablissementId?: InputMaybe<Scalars['String']>;
  formation?: InputMaybe<Scalars['String']>;
  formationId?: InputMaybe<Scalars['String']>;
  formationYear?: InputMaybe<Scalars['Int']>;
  option?: InputMaybe<Scalars['String']>;
  optionAutre?: InputMaybe<Scalars['String']>;
  optionMentionCMI?: InputMaybe<Scalars['String']>;
  pays?: InputMaybe<Scalars['String']>;
  secondFormation?: InputMaybe<SecondFormationInput>;
  skippingYear?: InputMaybe<Scalars['Boolean']>;
  skippingYearOccupation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  skippingYearOther?: InputMaybe<Scalars['String']>;
  ville?: InputMaybe<Scalars['String']>;
  year: Scalars['Int'];
};

export type SuccessResponse = {
  success?: Maybe<Scalars['Boolean']>;
};

export type User = {
  _id: Scalars['ID'];
  activitesBacPro?: Maybe<Array<Maybe<BacProActivite>>>;
  algoApi?: Maybe<Scalars['String']>;
  algoDate?: Maybe<Scalars['DateTime']>;
  algoInput?: Maybe<Scalars['String']>;
  algoResults?: Maybe<Array<Maybe<AlgoResult>>>;
  contactRequestId?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** Current classe ID for Prof */
  currentClasseId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  /** User emails */
  emails?: Maybe<Array<Maybe<UserEmail>>>;
  isProfileComplete?: Maybe<Scalars['Boolean']>;
  isQuestionnaireComplete?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<PhoneNumber>;
  /** Pistes tied to an Eclaireur */
  pistes?: Maybe<Array<Maybe<Piste>>>;
  profile?: Maybe<UserProfile>;
  roles?: Maybe<Array<Maybe<Scalars['ID']>>>;
  ssoId?: Maybe<Scalars['String']>;
  stateOfMind?: Maybe<StateOfMind>;
  wasLyceenInspire?: Maybe<Scalars['Boolean']>;
};

export type UserClasseInput = {
  classeName: Scalars['String'];
  familleMetiers: Scalars['String'];
  filiere?: InputMaybe<Scalars['String']>;
  niveau: Scalars['String'];
};

export type UserEmail = {
  address: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type UserProfile = {
  actionsEtudes?: Maybe<Scalars['String']>;
  adequationCentresInteretsPriorites?: Maybe<Scalars['String']>;
  adequationMetierOuSecteurReve?: Maybe<Scalars['String']>;
  adequationPreferencesApprentissage?: Maybe<AdequationPreferencesApprentissage>;
  adequationQualites?: Maybe<Scalars['String']>;
  age?: Maybe<Scalars['Int']>;
  agroSectorActivity1?: Maybe<AgroSectorActivity1>;
  agroSectorActivity3?: Maybe<AgroSectorActivity3>;
  algoResultsRating?: Maybe<Scalars['Int']>;
  analyseOffreEmploi?: Maybe<Array<Maybe<Scalars['String']>>>;
  apprentissage?: Maybe<Scalars['Boolean']>;
  aspirationsCeEnQuoiJeSuisFort?: Maybe<Scalars['String']>;
  aspirationsCentresInterets?: Maybe<Scalars['String']>;
  aspirationsForcesUtiles?: Maybe<Scalars['String']>;
  aspirationsMetiersQuiInteressaient?: Maybe<Scalars['String']>;
  aspirationsMetiersQuiInteressent?: Maybe<Scalars['String']>;
  aspirationsOntEvolue?: Maybe<Scalars['String']>;
  aspirationsPointsCommunsMetiersCentresInterets?: Maybe<Scalars['String']>;
  aspirationsPointsCommunsMetiersValeurs?: Maybe<Scalars['String']>;
  attitudes?: Maybe<Array<Maybe<IntAnswerField>>>;
  avenirPro?: Maybe<Array<Maybe<IntAnswerField>>>;
  bilansModules?: Maybe<Array<Maybe<BilanModule>>>;
  birthDate?: Maybe<Scalars['DateTime']>;
  boostAlternanceApprentissage?: Maybe<Scalars['Int']>;
  boostBudget?: Maybe<Scalars['Int']>;
  boostConnaisPersonne?: Maybe<Scalars['Int']>;
  boostPartir?: Maybe<Scalars['Int']>;
  boursierLycee?: Maybe<Scalars['String']>;
  capacitesMethodologiquesADevelopper?: Maybe<Array<Maybe<Scalars['String']>>>;
  capacitesMethodologiquesStage?: Maybe<Array<Maybe<Scalars['String']>>>;
  capacitesPersonnellesADevelopper?: Maybe<Array<Maybe<Scalars['String']>>>;
  capacitesPersonnellesStage?: Maybe<Array<Maybe<Scalars['String']>>>;
  capacitesSocialesADevelopper?: Maybe<Array<Maybe<Scalars['String']>>>;
  capacitesSocialesStage?: Maybe<Array<Maybe<Scalars['String']>>>;
  centresDinterets?: Maybe<CentresDinterets>;
  checklistCV?: Maybe<Array<Maybe<Scalars['String']>>>;
  checklistLM?: Maybe<Array<Maybe<Scalars['String']>>>;
  choixFormation?: Maybe<ChoixFormation>;
  codePostal?: Maybe<Scalars['String']>;
  competencesActivite?: Maybe<Scalars['String']>;
  competencesList?: Maybe<Array<Maybe<Scalars['String']>>>;
  connaitCoutEtudes?: Maybe<Scalars['Int']>;
  connaitPersonnesMemeDomaine?: Maybe<Scalars['Int']>;
  creationEntrepriseOpinion?: Maybe<Array<Maybe<Scalars['String']>>>;
  debouches?: Maybe<Array<Maybe<IntAnswerField>>>;
  demenagement?: Maybe<Scalars['String']>;
  departement?: Maybe<Scalars['String']>;
  derniereExperienceStage?: Maybe<Scalars['String']>;
  difficulteTrouverStage?: Maybe<Scalars['Int']>;
  diplomes?: Maybe<Array<Maybe<Scalars['String']>>>;
  domains?: Maybe<Array<Maybe<Domain>>>;
  eclaireurQuestions?: Maybe<Array<Maybe<StringAnswerField>>>;
  encadrement?: Maybe<Scalars['String']>;
  entretienFeedback?: Maybe<Array<Maybe<StringAnswerField>>>;
  environnement?: Maybe<Array<Maybe<Environnement>>>;
  etapesEntreprise?: Maybe<Array<Maybe<IntAnswerField>>>;
  etapesProjet?: Maybe<Array<Maybe<Scalars['String']>>>;
  experienceStage?: Maybe<Scalars['String']>;
  favoriteEclaireurs?: Maybe<Array<Maybe<FavoriteEclaireur>>>;
  favoritePistes?: Maybe<Array<Maybe<FavoritePiste>>>;
  filiere?: Maybe<Scalars['String']>;
  filiereBacPro?: Maybe<Scalars['String']>;
  filiereTechno?: Maybe<Scalars['String']>;
  financementEtudesFrein?: Maybe<Scalars['Int']>;
  firstName?: Maybe<Scalars['String']>;
  fonction?: Maybe<Scalars['String']>;
  fonctionAutre?: Maybe<Scalars['String']>;
  formationChoixPiste?: Maybe<Scalars['String']>;
  formationComparaisons?: Maybe<Array<Maybe<FormationComparaisons>>>;
  formationCompetencesTransversales?: Maybe<Scalars['String']>;
  formationEtablissements?: Maybe<Scalars['String']>;
  formationEvaluationMotivation?: Maybe<Scalars['String']>;
  formationMatiereBonsResultats?: Maybe<Scalars['String']>;
  formationMesExperiencesUtiles?: Maybe<Scalars['String']>;
  formationMesPointsAmelioration?: Maybe<Scalars['String']>;
  formationMesPointsForts?: Maybe<Scalars['String']>;
  formationMotiveApports?: Maybe<Scalars['String']>;
  formationMotiveAtouts?: Maybe<Scalars['String']>;
  formationMotiveCadre?: Maybe<Scalars['String']>;
  formationMotiveContexte?: Maybe<Scalars['String']>;
  formationMotiveDemarches?: Maybe<Scalars['String']>;
  formationMotiveQualites?: Maybe<Scalars['String']>;
  formationMoyenne?: Maybe<Scalars['Int']>;
  formationPointsForts?: Maybe<Array<Maybe<Scalars['String']>>>;
  formationRoute?: Maybe<Scalars['String']>;
  formationSavoirsEtre?: Maybe<Scalars['String']>;
  formationSelective?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  gererBudget?: Maybe<Scalars['String']>;
  hadInspirePresentation?: Maybe<Scalars['Boolean']>;
  hasOptions?: Maybe<Scalars['Boolean']>;
  howToImproveQualite?: Maybe<Scalars['String']>;
  imageValeur?: Maybe<Scalars['String']>;
  imagineDans5ans?: Maybe<Scalars['String']>;
  inscriptionPedagogique?: Maybe<Scalars['Boolean']>;
  isBoursierSecondaire?: Maybe<Scalars['String']>;
  isLyceenPrioritaire?: Maybe<Scalars['Boolean']>;
  isNiveauConfirmed?: Maybe<Scalars['Boolean']>;
  knewNobodyBacP1?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  lettreDeMotiv?: Maybe<Array<Maybe<StringAnswerField>>>;
  livedWithFamilyBacP1?: Maybe<Scalars['Boolean']>;
  logementEtudiant?: Maybe<Scalars['Boolean']>;
  lycee?: Maybe<Scalars['String']>;
  lyceeCity?: Maybe<Scalars['String']>;
  lyceeId?: Maybe<Scalars['String']>;
  lyceeStudies?: Maybe<Array<Maybe<LyceeStudiesItem>>>;
  matieres?: Maybe<Array<Maybe<Matiere>>>;
  matieresPreferes?: Maybe<Array<Maybe<Scalars['String']>>>;
  meConnaitreQualites?: Maybe<Array<Maybe<Scalars['String']>>>;
  mesQualites?: Maybe<Array<Maybe<Scalars['String']>>>;
  mesQuestionnements?: Maybe<Array<Maybe<Scalars['String']>>>;
  metierOuSecteurReve?: Maybe<MetierOuSecteurReve>;
  motivation?: Maybe<Array<Maybe<Scalars['String']>>>;
  motivationsEtudes?: Maybe<Scalars['String']>;
  motivationsTravail?: Maybe<Scalars['String']>;
  motsclesValeur?: Maybe<Array<Maybe<Scalars['String']>>>;
  moyennePremiere?: Maybe<Scalars['Int']>;
  newsletter?: Maybe<Scalars['Boolean']>;
  niveau?: Maybe<Scalars['String']>;
  notifications?: Maybe<Notifications>;
  obendyPixelAnalyticsUrl?: Maybe<Scalars['String']>;
  obendyWidgetUrl?: Maybe<Scalars['String']>;
  options_terminale?: Maybe<Array<Maybe<Scalars['String']>>>;
  partnership?: Maybe<Scalars['String']>;
  pedagogie_filiere_generale?: Maybe<Scalars['Boolean']>;
  pedagogie_filiere_professionnelle?: Maybe<Scalars['Boolean']>;
  pedagogie_filiere_technologique?: Maybe<Scalars['Boolean']>;
  picture?: Maybe<Scalars['String']>;
  pisteIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  pisteName?: Maybe<Scalars['String']>;
  pistesOpinions?: Maybe<Array<Maybe<PisteOpinion>>>;
  planActionComplementaire?: Maybe<Scalars['String']>;
  planActionEntreprendre?: Maybe<Scalars['String']>;
  planActionObjectif?: Maybe<Scalars['String']>;
  planActionTemps?: Maybe<Scalars['String']>;
  pointsFortsScolaires?: Maybe<PointsFortsScolaires>;
  preferenceEmploiDuTemps?: Maybe<Scalars['String']>;
  preferenceEncadrement?: Maybe<Scalars['String']>;
  preferenceFormatClasse?: Maybe<Scalars['String']>;
  preferenceRevisions?: Maybe<Scalars['String']>;
  preferencesApprentissage?: Maybe<Array<Maybe<Scalars['String']>>>;
  previsionAnneesEtudesPostBac?: Maybe<Scalars['Int']>;
  previsionEloignementDomicileParental?: Maybe<Scalars['String']>;
  previsionOccupationPostBac?: Maybe<Scalars['String']>;
  previsionQuitterDomicileParental?: Maybe<Scalars['Boolean']>;
  previsionTempsMaxTrajetParJour?: Maybe<Scalars['String']>;
  previsionTypeTransport?: Maybe<Array<Maybe<Scalars['String']>>>;
  prevoitCreerEntreprise?: Maybe<Scalars['Boolean']>;
  prioritesAvenir?: Maybe<Array<Maybe<Scalars['String']>>>;
  prochainesEtapes?: Maybe<Array<Maybe<ProchaineEtape>>>;
  qualitesAmeliorer?: Maybe<Array<Maybe<Scalars['String']>>>;
  referredBy?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  rencontrerDuMonde?: Maybe<Array<Maybe<Scalars['String']>>>;
  ressentiFormation?: Maybe<Scalars['Int']>;
  role?: Maybe<Scalars['String']>;
  secteursCompetencesADevelopper?: Maybe<Scalars['String']>;
  secteursCompetencesTransversales?: Maybe<Scalars['String']>;
  secteursInterets?: Maybe<Array<Maybe<Scalars['String']>>>;
  softSkillEvaluations?: Maybe<Array<Maybe<StringAnswerField>>>;
  softSkillsActions?: Maybe<Scalars['String']>;
  softSkillsAmeliorations?: Maybe<Scalars['String']>;
  softSkillsDifficultes?: Maybe<Array<Maybe<Scalars['String']>>>;
  softSkillsExperience?: Maybe<Scalars['String']>;
  softSkillsList?: Maybe<Array<Maybe<Scalars['String']>>>;
  softSkillsPlanAction?: Maybe<Scalars['String']>;
  softSkillsRessenti?: Maybe<Array<Maybe<Scalars['String']>>>;
  sourceOfFinanceStudies?: Maybe<Array<Maybe<Scalars['String']>>>;
  speBac?: Maybe<Scalars['String']>;
  spe_abandonnee_premiere?: Maybe<Array<Maybe<Scalars['String']>>>;
  spes_premiere?: Maybe<Array<Maybe<Scalars['String']>>>;
  spes_terminale?: Maybe<Array<Maybe<Scalars['String']>>>;
  stageCapacitesMethodologiques?: Maybe<Scalars['String']>;
  stageCapacitesPersonnelles?: Maybe<Scalars['String']>;
  stageCapacitesSociales?: Maybe<Scalars['String']>;
  stageDuree?: Maybe<Scalars['String']>;
  stageEntrepriseActivite?: Maybe<Scalars['String']>;
  stageEntrepriseSoftSkills?: Maybe<Scalars['String']>;
  stageGeographie?: Maybe<Scalars['String']>;
  stageMetier?: Maybe<Scalars['String']>;
  stageMissions?: Maybe<Scalars['String']>;
  stageMotsCles?: Maybe<Scalars['String']>;
  stageSecteurActivite?: Maybe<Scalars['String']>;
  stageSite?: Maybe<Scalars['String']>;
  stageTypeEntreprise?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  studiedAbroad?: Maybe<Scalars['Boolean']>;
  studies?: Maybe<Array<Maybe<StudyYear>>>;
  studiesFirstYear?: Maybe<Scalars['Int']>;
  tagline?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  typeLogement?: Maybe<Array<Maybe<Scalars['String']>>>;
  update_newsletter?: Maybe<Scalars['DateTime']>;
  vieEtudianteAideDemenagement?: Maybe<Scalars['String']>;
  vieEtudianteDemenager?: Maybe<Scalars['String']>;
  vieEtudianteFinancement?: Maybe<Scalars['String']>;
  vieEtudianteQuestionsAuxEclaireurs?: Maybe<Scalars['String']>;
  vieEtudianteTypeLogement?: Maybe<Scalars['String']>;
  willReviewCV?: Maybe<Scalars['Boolean']>;
};

export type UserProfileInput = {
  actionsEtudes?: InputMaybe<Scalars['String']>;
  adequationCentresInteretsPriorites?: InputMaybe<Scalars['String']>;
  adequationMetierOuSecteurReve?: InputMaybe<Scalars['String']>;
  adequationPreferencesApprentissage?: InputMaybe<AdequationPreferencesApprentissageInput>;
  adequationQualites?: InputMaybe<Scalars['String']>;
  agroSectorActivity1?: InputMaybe<AgroSectorActivity1Input>;
  agroSectorActivity3?: InputMaybe<AgroSectorActivity3Input>;
  algoResultsRating?: InputMaybe<Scalars['Int']>;
  analyseOffreEmploi?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  apprentissage?: InputMaybe<Scalars['Boolean']>;
  aspirationsCeEnQuoiJeSuisFort?: InputMaybe<Scalars['String']>;
  aspirationsCentresInterets?: InputMaybe<Scalars['String']>;
  aspirationsForcesUtiles?: InputMaybe<Scalars['String']>;
  aspirationsMetiersQuiInteressaient?: InputMaybe<Scalars['String']>;
  aspirationsMetiersQuiInteressent?: InputMaybe<Scalars['String']>;
  aspirationsOntEvolue?: InputMaybe<Scalars['String']>;
  aspirationsPointsCommunsMetiersCentresInterets?: InputMaybe<Scalars['String']>;
  aspirationsPointsCommunsMetiersValeurs?: InputMaybe<Scalars['String']>;
  attitudes?: InputMaybe<Array<InputMaybe<IntAnswerFieldInput>>>;
  avenirPro?: InputMaybe<Array<InputMaybe<IntAnswerFieldInput>>>;
  birthDate?: InputMaybe<Scalars['DateTime']>;
  boostAlternanceApprentissage?: InputMaybe<Scalars['Int']>;
  boostBudget?: InputMaybe<Scalars['Int']>;
  boostConnaisPersonne?: InputMaybe<Scalars['Int']>;
  boostPartir?: InputMaybe<Scalars['Int']>;
  boursierLycee?: InputMaybe<Scalars['String']>;
  capacitesMethodologiquesADevelopper?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  capacitesMethodologiquesStage?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  capacitesPersonnellesADevelopper?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  capacitesPersonnellesStage?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  capacitesSocialesADevelopper?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  capacitesSocialesStage?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  centresDinterets?: InputMaybe<CentresDinteretsInput>;
  checklistCV?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  checklistLM?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  choixFormation?: InputMaybe<ChoixFormationInput>;
  codePostal?: InputMaybe<Scalars['String']>;
  competencesActivite?: InputMaybe<Scalars['String']>;
  competencesList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  connaitCoutEtudes?: InputMaybe<Scalars['Int']>;
  connaitPersonnesMemeDomaine?: InputMaybe<Scalars['Int']>;
  creationEntrepriseOpinion?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  debouches?: InputMaybe<Array<InputMaybe<IntAnswerFieldInput>>>;
  demenagement?: InputMaybe<Scalars['String']>;
  departement?: InputMaybe<Scalars['String']>;
  derniereExperienceStage?: InputMaybe<Scalars['String']>;
  difficulteTrouverStage?: InputMaybe<Scalars['Int']>;
  diplomes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  domains?: InputMaybe<Array<InputMaybe<DomainInput>>>;
  eclaireurQuestions?: InputMaybe<EclaireurQuestionsInput>;
  email?: InputMaybe<Scalars['String']>;
  encadrement?: InputMaybe<Scalars['String']>;
  entretienFeedback?: InputMaybe<Array<InputMaybe<StringAnswerFieldInput>>>;
  environnement?: InputMaybe<Array<InputMaybe<EnvironnementInput>>>;
  etapesEntreprise?: InputMaybe<Array<InputMaybe<IntAnswerFieldInput>>>;
  etapesProjet?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  experienceStage?: InputMaybe<Scalars['String']>;
  favoriteEclaireurs?: InputMaybe<Array<InputMaybe<FavoriteEclaireurInput>>>;
  favoritePistes?: InputMaybe<Array<InputMaybe<FavoritePisteInput>>>;
  financementEtudesFrein?: InputMaybe<Scalars['Int']>;
  firstName?: InputMaybe<Scalars['String']>;
  fonction?: InputMaybe<Scalars['String']>;
  fonctionAutre?: InputMaybe<Scalars['String']>;
  formationChoixPiste?: InputMaybe<Scalars['String']>;
  formationComparaisons?: InputMaybe<Array<InputMaybe<FormationComparaisonsInput>>>;
  formationCompetencesTransversales?: InputMaybe<Scalars['String']>;
  formationEtablissements?: InputMaybe<Scalars['String']>;
  formationEvaluationMotivation?: InputMaybe<Scalars['String']>;
  formationMatiereBonsResultats?: InputMaybe<Scalars['String']>;
  formationMesExperiencesUtiles?: InputMaybe<Scalars['String']>;
  formationMesPointsAmelioration?: InputMaybe<Scalars['String']>;
  formationMesPointsForts?: InputMaybe<Scalars['String']>;
  formationMotiveApports?: InputMaybe<Scalars['String']>;
  formationMotiveAtouts?: InputMaybe<Scalars['String']>;
  formationMotiveCadre?: InputMaybe<Scalars['String']>;
  formationMotiveContexte?: InputMaybe<Scalars['String']>;
  formationMotiveDemarches?: InputMaybe<Scalars['String']>;
  formationMotiveQualites?: InputMaybe<Scalars['String']>;
  formationMoyenne?: InputMaybe<Scalars['Int']>;
  formationPointsForts?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  formationRoute?: InputMaybe<Scalars['String']>;
  formationSavoirsEtre?: InputMaybe<Scalars['String']>;
  formationSelective?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  gererBudget?: InputMaybe<Scalars['String']>;
  hadInspirePresentation?: InputMaybe<Scalars['Boolean']>;
  hasOptions?: InputMaybe<Scalars['Boolean']>;
  howToImproveQualite?: InputMaybe<Scalars['String']>;
  imageValeur?: InputMaybe<Scalars['String']>;
  imagineDans5ans?: InputMaybe<Scalars['String']>;
  inscriptionPedagogique?: InputMaybe<Scalars['Boolean']>;
  isBoursierSecondaire?: InputMaybe<Scalars['String']>;
  isLyceenPrioritaire?: InputMaybe<Scalars['Boolean']>;
  knewNobodyBacP1?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  lettreDeMotiv?: InputMaybe<Array<InputMaybe<StringAnswerFieldInput>>>;
  livedWithFamilyBacP1?: InputMaybe<Scalars['Boolean']>;
  logementEtudiant?: InputMaybe<Scalars['Boolean']>;
  lycee?: InputMaybe<Scalars['String']>;
  lyceeCity?: InputMaybe<Scalars['String']>;
  lyceeId?: InputMaybe<Scalars['String']>;
  lyceeStudies?: InputMaybe<Array<InputMaybe<LyceeStudiesItemInput>>>;
  matieres?: InputMaybe<Array<InputMaybe<MatiereInput>>>;
  matieresPreferes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  meConnaitreQualites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mesQualites?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  mesQuestionnements?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  metierOuSecteurReve?: InputMaybe<MetierOuSecteurReveInput>;
  motivation?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  motivationsEtudes?: InputMaybe<Scalars['String']>;
  motivationsTravail?: InputMaybe<Scalars['String']>;
  motsclesValeur?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moyennePremiere?: InputMaybe<Scalars['Int']>;
  newsletter?: InputMaybe<Scalars['Boolean']>;
  notifications?: InputMaybe<NotificationsInput>;
  options_terminale?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pedagogie_filiere_generale?: InputMaybe<Scalars['Boolean']>;
  pedagogie_filiere_professionnelle?: InputMaybe<Scalars['Boolean']>;
  pedagogie_filiere_technologique?: InputMaybe<Scalars['Boolean']>;
  picture?: InputMaybe<Scalars['String']>;
  pisteIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pistesOpinions?: InputMaybe<Array<InputMaybe<PisteOpinionInput>>>;
  planActionComplementaire?: InputMaybe<Scalars['String']>;
  planActionEntreprendre?: InputMaybe<Scalars['String']>;
  planActionObjectif?: InputMaybe<Scalars['String']>;
  planActionTemps?: InputMaybe<Scalars['String']>;
  pointsFortsScolaires?: InputMaybe<PointsFortsScolairesInput>;
  preferenceEmploiDuTemps?: InputMaybe<Scalars['String']>;
  preferenceEncadrement?: InputMaybe<Scalars['String']>;
  preferenceFormatClasse?: InputMaybe<Scalars['String']>;
  preferenceRevisions?: InputMaybe<Scalars['String']>;
  preferencesApprentissage?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  previsionAnneesEtudesPostBac?: InputMaybe<Scalars['Int']>;
  previsionEloignementDomicileParental?: InputMaybe<Scalars['String']>;
  previsionOccupationPostBac?: InputMaybe<Scalars['String']>;
  previsionQuitterDomicileParental?: InputMaybe<Scalars['Boolean']>;
  previsionTempsMaxTrajetParJour?: InputMaybe<Scalars['String']>;
  previsionTypeTransport?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  prevoitCreerEntreprise?: InputMaybe<Scalars['Boolean']>;
  prioritesAvenir?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  prochainesEtapes?: InputMaybe<Array<InputMaybe<ProchaineEtapeInput>>>;
  qualitesAmeliorer?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  referredBy?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  rencontrerDuMonde?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  ressentiFormation?: InputMaybe<Scalars['Int']>;
  secteursCompetencesADevelopper?: InputMaybe<Scalars['String']>;
  secteursCompetencesTransversales?: InputMaybe<Scalars['String']>;
  secteursInterets?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  softSkillEvaluations?: InputMaybe<Array<InputMaybe<StringAnswerFieldInput>>>;
  softSkillsActions?: InputMaybe<Scalars['String']>;
  softSkillsAmeliorations?: InputMaybe<Scalars['String']>;
  softSkillsDifficultes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  softSkillsExperience?: InputMaybe<Scalars['String']>;
  softSkillsList?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  softSkillsPlanAction?: InputMaybe<Scalars['String']>;
  softSkillsRessenti?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sourceOfFinanceStudies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spe_abandonnee_premiere?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spes_premiere?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  spes_terminale?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stageCapacitesMethodologiques?: InputMaybe<Scalars['String']>;
  stageCapacitesPersonnelles?: InputMaybe<Scalars['String']>;
  stageCapacitesSociales?: InputMaybe<Scalars['String']>;
  stageDuree?: InputMaybe<Scalars['String']>;
  stageEntrepriseActivite?: InputMaybe<Scalars['String']>;
  stageEntrepriseSoftSkills?: InputMaybe<Scalars['String']>;
  stageGeographie?: InputMaybe<Scalars['String']>;
  stageMetier?: InputMaybe<Scalars['String']>;
  stageMissions?: InputMaybe<Scalars['String']>;
  stageMotsCles?: InputMaybe<Scalars['String']>;
  stageSecteurActivite?: InputMaybe<Scalars['String']>;
  stageSite?: InputMaybe<Scalars['String']>;
  stageTypeEntreprise?: InputMaybe<Scalars['String']>;
  studiedAbroad?: InputMaybe<Scalars['Boolean']>;
  studiesFirstYear?: InputMaybe<Scalars['Int']>;
  tagline?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  typeLogement?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  update_newsletter?: InputMaybe<Scalars['DateTime']>;
  vieEtudianteAideDemenagement?: InputMaybe<Scalars['String']>;
  vieEtudianteDemenager?: InputMaybe<Scalars['String']>;
  vieEtudianteFinancement?: InputMaybe<Scalars['String']>;
  vieEtudianteQuestionsAuxEclaireurs?: InputMaybe<Scalars['String']>;
  vieEtudianteTypeLogement?: InputMaybe<Scalars['String']>;
  willReviewCV?: InputMaybe<Scalars['Boolean']>;
};

export type AdequationPreferencesApprentissage = {
  correspond: Scalars['String'];
  pourquoiNon?: Maybe<Scalars['String']>;
};

export type AdequationPreferencesApprentissageInput = {
  correspond: Scalars['String'];
  pourquoiNon?: InputMaybe<Scalars['String']>;
};

export type AgroSectorActivity1 = {
  mots?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AgroSectorActivity1Input = {
  mots?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AgroSectorActivity3 = {
  continueStudiesOrProLife?: Maybe<Scalars['String']>;
  whatDoIlikeMostAfterBac?: Maybe<Array<Maybe<Scalars['String']>>>;
  whatDoIlikeMostContinueStudies?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type AgroSectorActivity3Input = {
  continueStudiesOrProLife?: InputMaybe<Scalars['String']>;
  whatDoIlikeMostAfterBac?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  whatDoIlikeMostContinueStudies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type ChoixFormation = {
  choisiFormation: Scalars['String'];
  interessant?: Maybe<Scalars['String']>;
  pourquoiChoisi?: Maybe<Scalars['String']>;
};

export type ChoixFormationInput = {
  choisiFormation: Scalars['String'];
  interessant?: InputMaybe<Scalars['String']>;
  pourquoiChoisi?: InputMaybe<Scalars['String']>;
};

export type LyceeStudiesItem = {
  annee: Scalars['Int'];
  filiere?: Maybe<Scalars['String']>;
  filiereBacPro?: Maybe<Scalars['String']>;
  filiereTechno?: Maybe<Scalars['String']>;
  isConfirmed?: Maybe<Scalars['Boolean']>;
  niveau: Scalars['String'];
};

export type LyceeStudiesItemInput = {
  annee: Scalars['Int'];
  filiere?: InputMaybe<Scalars['String']>;
  filiereBacPro?: InputMaybe<Scalars['String']>;
  filiereTechno?: InputMaybe<Scalars['String']>;
  niveau: Scalars['String'];
};

export type PointsFortsScolaires = {
  correspondentAuxMatieresPreferees: Scalars['String'];
  meilleuresMatieres: Array<Maybe<Scalars['String']>>;
};

export type PointsFortsScolairesInput = {
  correspondentAuxMatieresPreferees: Scalars['String'];
  meilleuresMatieres: Array<InputMaybe<Scalars['String']>>;
};

export type ProchaineEtape = {
  name?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type ProchaineEtapeInput = {
  name?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export type CreateEclaireurMutationVariables = Exact<{
  profile: UserProfileInput;
}>;


export type CreateEclaireurMutation = { createEclaireur?: { id: string, token: string, tokenExpires: number, ssoId: string } | null };

export type CreateLyceenMutationVariables = Exact<{
  profile: UserProfileInput;
  signupToken?: InputMaybe<Scalars['String']>;
}>;


export type CreateLyceenMutation = { createLyceen?: { id: string, token: string, tokenExpires: number, ssoId: string } | null };

export type CreateLyceenHorsScopeMutationVariables = Exact<{
  niveau: Scalars['String'];
}>;


export type CreateLyceenHorsScopeMutation = { createLyceenHorsScope?: any | null };

export type CreateProfMutationVariables = Exact<{
  profile: UserProfileInput;
}>;


export type CreateProfMutation = { createProf?: { id: string, token: string, tokenExpires: number, ssoId: string } | null };

export type DeleteMyAccountMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteMyAccountMutation = { deleteMyAccount?: number | null };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type ForgotPasswordMutation = { forgotPassword?: { success?: boolean | null } | null };

export type ResendVerificationEmailMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendVerificationEmailMutation = { resendVerificationEmail?: { success?: boolean | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  newPassword: HashedPassword;
  token: Scalars['String'];
}>;


export type ResetPasswordMutation = { resetPassword?: { id: string } | null };

export type VerifyEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyEmailMutation = { verifyEmail?: { id: string, token: string, tokenExpires: number } | null };

export type ArticlesQueryVariables = Exact<{
  filters?: InputMaybe<ArticleQueryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  tag?: InputMaybe<Scalars['String']>;
}>;


export type ArticlesQuery = { articles: Array<{ _id?: string | null, title?: string | null, slug?: string | null, coverPicture?: string | null, createdAt?: any | null, tags?: Array<string | null> | null, tag?: string | null, chapo?: string | null, subtag?: string | null, excerpt?: string | null } | null> };

export type CreateContactRequestMutationVariables = Exact<{
  requestFor: Scalars['ID'];
  group?: InputMaybe<Scalars['String']>;
}>;


export type CreateContactRequestMutation = { createContactRequest?: string | null };

export type MarkThreadAsSeenMutationVariables = Exact<{
  threadId: Scalars['String'];
}>;


export type MarkThreadAsSeenMutation = { markThreadAsSeen?: any | null };

export type MyContactRequestsQueryVariables = Exact<{
  threadId?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type MyContactRequestsQuery = { myContactRequests?: Array<{ _id?: string | null, requestBy?: string | null, requestFor?: string | null, updatedAt?: any | null, hasNewMessage?: boolean | null, problemLyceen?: string | null, problemEclaireur?: string | null, hasSentIntroMessage?: boolean | null, contactInfo?: { _id?: string | null, firstName?: string | null, pisteIds?: Array<string | null> | null, picture?: string | null, age?: number | null, role?: string | null, niveau?: string | null, filiere?: string | null, filiereTechno?: string | null, filiereBacPro?: string | null, pistes?: Array<{ name?: string | null } | null> | null } | null, exchangeStats?: { lastMessageDate?: any | null } | null } | null> | null };

export type SendMessageMutationVariables = Exact<{
  threadId: Scalars['String'];
  content: Scalars['String'];
  introQuestionKey?: InputMaybe<Scalars['String']>;
  introQuestionCategory?: InputMaybe<Scalars['String']>;
}>;


export type SendMessageMutation = { sendMessage?: any | null };

export type SignalProblemMutationVariables = Exact<{
  threadId: Scalars['String'];
  problem: Scalars['String'];
}>;


export type SignalProblemMutation = { signalProblem?: any | null };

export type ChatThreadByIdQueryVariables = Exact<{
  threadId: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type ChatThreadByIdQuery = { messagesByThreadId?: Array<{ _id: string, threadId: string, sender: string, recipients: Array<string | null>, content: string, timestamp: number, type?: string | null, introQuestionKey?: string | null, introQuestionCategory?: string | null } | null> | null };

export type AllClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllClassesQuery = { allClasses: Array<{ _id?: string | null, classeName?: string | null, modulesCounter?: number | null } | null> };

export type ChangeCurrentClasseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ChangeCurrentClasseMutation = { changeCurrentClasse?: any | null };

export type ClasseByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ClasseByIdQuery = { classeById?: { _id?: string | null, classeName?: string | null, niveau?: string | null, familleMetiers?: string | null, filiere?: string | null, filiereBacPro?: string | null, filiereTechno?: string | null, signupToken?: string | null, anneeScolaire?: number | null, lyceeId?: string | null, eleves?: Array<{ _id: string, profile?: { firstName?: string | null, lastName?: string | null } | null } | null> | null } | null };

export type ClasseByTokenQueryVariables = Exact<{
  signupToken: Scalars['String'];
}>;


export type ClasseByTokenQuery = { classeByToken?: { _id?: string | null, niveau?: string | null, filiere?: string | null, familleMetiers?: string | null, filiereBacPro?: string | null, filiereTechno?: string | null, classeName?: string | null, profs?: Array<{ profile?: { title?: string | null, firstName?: string | null, lastName?: string | null } | null } | null> | null, lycee?: { nom: string, ville: string } | null } | null };

export type ClasseProfsQueryVariables = Exact<{
  classeId: Scalars['ID'];
}>;


export type ClasseProfsQuery = { classeById?: { profs?: Array<{ _id: string, profile?: { firstName?: string | null, lastName?: string | null } | null } | null> | null } | null };

export type CreateClasseMutationVariables = Exact<{
  input: ClasseInput;
}>;


export type CreateClasseMutation = { createClasse?: string | null };

export type CurrentClasseForLyceenQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentClasseForLyceenQuery = { currentClasse?: { _id?: string | null, classeName?: string | null, niveau?: string | null, filiere?: string | null, filiereBacPro?: string | null, filiereTechno?: string | null, familleMetiers?: string | null, anneeScolaire?: number | null, lyceeId?: string | null, lycee?: { nom: string, ville: string, departement: string, departementCode: string, academie?: string | null, isPrioritaire?: boolean | null } | null, modules?: Array<{ moduleId: string, disabled?: boolean | null, disabledActivites?: Array<string | null> | null } | null> | null } | null };

export type CurrentClasseForProfQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentClasseForProfQuery = { currentClasse?: { _id?: string | null, classeName?: string | null, niveau?: string | null, familleMetiers?: string | null, filiere?: string | null, filiereBacPro?: string | null, filiereTechno?: string | null, signupToken?: string | null, anneeScolaire?: number | null, lyceeId?: string | null, pays?: string | null, lyceeEtrangerName?: string | null, eleves?: Array<{ _id: string, profile?: { firstName?: string | null, lastName?: string | null } | null } | null> | null, modules?: Array<{ moduleId: string, disabled?: boolean | null, disabledActivites?: Array<string | null> | null } | null> | null, lycee?: { nom: string, ville: string, departement: string, departementCode: string, academie?: string | null, isPrioritaire?: boolean | null } | null } | null };

export type DeleteClasseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteClasseMutation = { deleteClasse?: any | null };

export type GenerateTokenMutationVariables = Exact<{
  classeId: Scalars['ID'];
}>;


export type GenerateTokenMutation = { generateToken?: any | null };

export type ImportElevesMutationVariables = Exact<{
  classeId: Scalars['ID'];
  eleveIds: Array<Scalars['ID']> | Scalars['ID'];
}>;


export type ImportElevesMutation = { importEleves?: any | null };

export type JoinClasseMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type JoinClasseMutation = { joinClasse?: any | null };

export type QuitClasseMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type QuitClasseMutation = { quitClasse?: any | null };

export type RemoveEleveFromClasseMutationVariables = Exact<{
  classeId: Scalars['ID'];
  eleveId: Scalars['ID'];
}>;


export type RemoveEleveFromClasseMutation = { removeEleveFromClasse?: boolean | null };

export type UpdateClasseMutationVariables = Exact<{
  classeId: Scalars['String'];
  input: ClasseInput;
}>;


export type UpdateClasseMutation = { updateClasse?: any | null };

export type UpdateModuleMutationVariables = Exact<{
  classeId: Scalars['String'];
  moduleConfig: ModuleConfigInput;
}>;


export type UpdateModuleMutation = { updateModule?: { _id?: string | null } | null };

export type GitInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GitInfoQuery = { gitInfo?: { sha?: string | null, message?: string | null } | null };

export type EtablissementsQueryVariables = Exact<{
  departement: Scalars['String'];
}>;


export type EtablissementsQuery = { etablissements: Array<{ _id: string, name: string, idEtablissementOnisep?: string | null, commune?: string | null } | null> };

export type FaqItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type FaqItemsQuery = { faqItems: Array<{ _id: string, question: string, answer: string } | null> };

export type FormationsQueryVariables = Exact<{
  onisepId: Scalars['String'];
}>;


export type FormationsQuery = { formations: Array<{ _id: string, name: string } | null> };

export type LyceesQueryVariables = Exact<{
  departement?: InputMaybe<Scalars['String']>;
  hasIntervention?: InputMaybe<Scalars['Boolean']>;
  isLyceePro?: InputMaybe<Scalars['Boolean']>;
}>;


export type LyceesQuery = { lycees: Array<{ _id: string, nom: string, ville: string, departement: string, departementCode: string, uai_ips?: string | null, location?: { type: string, coordinates?: any | null } | null } | null> };

export type PistesQueryVariables = Exact<{
  filiere?: InputMaybe<Scalars['String']>;
  domaines?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  isApprentissage?: InputMaybe<Scalars['Boolean']>;
  isInsertionPro?: InputMaybe<Scalars['Boolean']>;
  typesFormation?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  classeHasModules?: InputMaybe<Scalars['Boolean']>;
}>;


export type PistesQuery = { pistes: Array<{ _id?: string | null, name?: string | null, slug?: string | null, coverPicture?: string | null, bacs?: Array<string | null> | null, isInsertionPro?: boolean | null, typeFormation?: Array<string | null> | null } | null> };

export type PisteBySlugQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type PisteBySlugQuery = { piste?: { _id?: string | null, name?: string | null, slug?: string | null, coverPicture?: string | null, bacs?: Array<string | null> | null, chapo?: string | null, content?: string | null, contentBacPro?: string | null, updatedAt?: any | null, typeEtablissement?: string | null, typeEnseignement?: string | null, typeFormat?: string | null, duree?: string | null, disponibleEnApprentissage?: boolean | null, dureeStageFrom?: number | null, dureeStageTo?: number | null, pisteFeedback?: { hasFeedback?: boolean | null, knewThePiste?: boolean | null } | null } | null };

export type PisteByIdQueryVariables = Exact<{
  _id: Scalars['String'];
}>;


export type PisteByIdQuery = { piste?: { _id?: string | null, name?: string | null, slug?: string | null } | null };

export type SubmitPisteFeedbackMutationVariables = Exact<{
  input: PisteFeedbackInput;
}>;


export type SubmitPisteFeedbackMutation = { submitPisteFeedback?: string | null };

export type ResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type ResourcesQuery = { resources: Array<{ _id?: string | null, name?: string | null, url?: string | null, category?: string | null, type?: string | null, description?: string | null, order?: number | null } | null> };

export type AddProfMutationVariables = Exact<{
  classeId: Scalars['ID'];
  profId: Scalars['ID'];
}>;


export type AddProfMutation = { addProf?: any | null };

export type CountLyceenAlgoMutationVariables = Exact<{
  lyceenAlgoCounter: Scalars['String'];
}>;


export type CountLyceenAlgoMutation = { countLyceenAlgo?: any | null };

export type CreateCvdesignrUserMutationVariables = Exact<{
  cvdesignrPassword: Scalars['String'];
}>;


export type CreateCvdesignrUserMutation = { createCvdesignrUser?: string | null };

export type CvdesignrFlowQueryVariables = Exact<{ [key: string]: never; }>;


export type CvdesignrFlowQuery = { cvdesignrFlow?: { kind: string, value?: string | null } | null };

export type DeleteHorsScopeUserMutationVariables = Exact<{ [key: string]: never; }>;


export type DeleteHorsScopeUserMutation = { deleteHorsScopeUser?: any | null };

export type DevenirEclaireurMutationVariables = Exact<{ [key: string]: never; }>;


export type DevenirEclaireurMutation = { devenirEclaireur?: any | null };

export type EclaireurQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EclaireurQuery = { eclaireur?: { _id: string, contactRequestId?: string | null, wasLyceenInspire?: boolean | null, profile?: { status?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null, filiere?: string | null, filiereBacPro?: string | null, picture?: string | null, age?: number | null, studiesFirstYear?: number | null, sourceOfFinanceStudies?: Array<string | null> | null, livedWithFamilyBacP1?: boolean | null, knewNobodyBacP1?: boolean | null, willReviewCV?: boolean | null, apprentissage?: boolean | null, logementEtudiant?: boolean | null, studiedAbroad?: boolean | null, tagline?: string | null, speBac?: string | null, lycee?: string | null, lyceeCity?: string | null, departement?: string | null, studies?: Array<{ year?: number | null, formation?: string | null, etablissement?: string | null, formationYear?: number | null, ville?: string | null, codePostal?: string | null, skippingYear?: boolean | null, skippingYearOccupation?: Array<string | null> | null, option?: string | null, optionAutre?: string | null, optionMentionCMI?: string | null, skippingYearOther?: string | null, secondFormation?: { departement?: string | null, etablissement?: string | null, etablissementId?: string | null, formation?: string | null, formationId?: string | null, formationYear?: number | null, doubleDegree?: boolean | null, ville?: string | null, codePostal?: string | null } | null } | null> | null, eclaireurQuestions?: Array<{ key?: string | null, value?: string | null } | null> | null } | null, pistes?: Array<{ _id?: string | null, name?: string | null, coverPicture?: string | null, slug?: string | null } | null> | null } | null };

export type EclaireursQueryVariables = Exact<{
  filters?: InputMaybe<EclaireurQueryInput>;
  limit?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Scalars['String']>;
}>;


export type EclaireursQuery = { eclaireurs?: Array<{ _id: string, isProfileComplete?: boolean | null, profile?: { status?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null, filiere?: string | null, filiereBacPro?: string | null, picture?: string | null, age?: number | null, studiesFirstYear?: number | null, livedWithFamilyBacP1?: boolean | null, logementEtudiant?: boolean | null, sourceOfFinanceStudies?: Array<string | null> | null, knewNobodyBacP1?: boolean | null, apprentissage?: boolean | null, studiedAbroad?: boolean | null, lycee?: string | null, departement?: string | null, lyceeCity?: string | null, studies?: Array<{ year?: number | null, formation?: string | null, etablissement?: string | null, formationYear?: number | null, ville?: string | null, codePostal?: string | null, secondFormation?: { departement?: string | null, etablissement?: string | null, etablissementId?: string | null, formation?: string | null, formationId?: string | null, formationYear?: number | null, doubleDegree?: boolean | null, ville?: string | null, codePostal?: string | null } | null } | null> | null } | null, pistes?: Array<{ _id?: string | null, name?: string | null } | null> | null } | null> | null };

export type EleveQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type EleveQuery = { eleve?: { activitesBacPro?: Array<{ activiteId?: string | null, status?: string | null } | null> | null, profile?: { firstName?: string | null, lastName?: string | null, diplomes?: Array<string | null> | null, difficulteTrouverStage?: number | null, ressentiFormation?: number | null, softSkillsExperience?: string | null, softSkillsList?: Array<string | null> | null, softSkillsDifficultes?: Array<string | null> | null, softSkillsActions?: string | null, softSkillsRessenti?: Array<string | null> | null, softSkillsAmeliorations?: string | null, competencesActivite?: string | null, competencesList?: Array<string | null> | null, etapesProjet?: Array<string | null> | null, planActionObjectif?: string | null, planActionTemps?: string | null, planActionEntreprendre?: string | null, planActionComplementaire?: string | null, mesQualites?: Array<string | null> | null, qualitesAmeliorer?: Array<string | null> | null, howToImproveQualite?: string | null, stageDuree?: string | null, stageSecteurActivite?: string | null, stageMetier?: string | null, stageGeographie?: string | null, stageMissions?: string | null, stageTypeEntreprise?: string | null, stageMotsCles?: string | null, stageSite?: string | null, preferenceFormatClasse?: string | null, preferenceEncadrement?: string | null, preferenceRevisions?: string | null, preferenceEmploiDuTemps?: string | null, formationMotiveContexte?: string | null, formationMotiveDemarches?: string | null, formationMotiveApports?: string | null, formationMotiveCadre?: string | null, formationMotiveAtouts?: string | null, formationMotiveQualites?: string | null, typeLogement?: Array<string | null> | null, demenagement?: string | null, gererBudget?: string | null, rencontrerDuMonde?: Array<string | null> | null, formationRoute?: string | null, preferencesApprentissage?: Array<string | null> | null, prioritesAvenir?: Array<string | null> | null, matieresPreferes?: Array<string | null> | null, meConnaitreQualites?: Array<string | null> | null, adequationMetierOuSecteurReve?: string | null, adequationCentresInteretsPriorites?: string | null, adequationQualites?: string | null, experienceStage?: string | null, stageCapacitesSociales?: string | null, stageCapacitesPersonnelles?: string | null, stageCapacitesMethodologiques?: string | null, softSkillsPlanAction?: string | null, derniereExperienceStage?: string | null, capacitesSocialesStage?: Array<string | null> | null, capacitesPersonnellesStage?: Array<string | null> | null, capacitesMethodologiquesStage?: Array<string | null> | null, capacitesSocialesADevelopper?: Array<string | null> | null, capacitesPersonnellesADevelopper?: Array<string | null> | null, capacitesMethodologiquesADevelopper?: Array<string | null> | null, motivationsEtudes?: string | null, motivationsTravail?: string | null, actionsEtudes?: string | null, imagineDans5ans?: string | null, imageValeur?: string | null, motsclesValeur?: Array<string | null> | null, mesQuestionnements?: Array<string | null> | null, aspirationsMetiersQuiInteressaient?: string | null, aspirationsMetiersQuiInteressent?: string | null, aspirationsCentresInterets?: string | null, aspirationsCeEnQuoiJeSuisFort?: string | null, aspirationsOntEvolue?: string | null, aspirationsPointsCommunsMetiersValeurs?: string | null, aspirationsForcesUtiles?: string | null, aspirationsPointsCommunsMetiersCentresInterets?: string | null, secteursInterets?: Array<string | null> | null, secteursCompetencesTransversales?: string | null, secteursCompetencesADevelopper?: string | null, formationChoixPiste?: string | null, formationEtablissements?: string | null, formationSelective?: string | null, formationPointsForts?: Array<string | null> | null, formationMoyenne?: number | null, formationMatiereBonsResultats?: string | null, formationSavoirsEtre?: string | null, formationEvaluationMotivation?: string | null, formationCompetencesTransversales?: string | null, formationMesPointsForts?: string | null, formationMesPointsAmelioration?: string | null, formationMesExperiencesUtiles?: string | null, vieEtudianteDemenager?: string | null, vieEtudianteTypeLogement?: string | null, vieEtudianteAideDemenagement?: string | null, vieEtudianteFinancement?: string | null, vieEtudianteQuestionsAuxEclaireurs?: string | null, spes_premiere?: Array<string | null> | null, spes_terminale?: Array<string | null> | null, spe_abandonnee_premiere?: Array<string | null> | null, moyennePremiere?: number | null, motivation?: Array<string | null> | null, encadrement?: string | null, boostAlternanceApprentissage?: number | null, boostConnaisPersonne?: number | null, boostPartir?: number | null, boostBudget?: number | null, centresDinterets?: { centresDinterets: Array<string | null>, sport?: string | null, danse?: string | null, autre?: string | null } | null, metierOuSecteurReve?: { saitMetierOuSecteur: boolean, metierOuSecteur?: string | null, pourraitInteresser?: Array<string | null> | null } | null, choixFormation?: { choisiFormation: string, pourquoiChoisi?: string | null, interessant?: string | null } | null, adequationPreferencesApprentissage?: { correspond: string, pourquoiNon?: string | null } | null, pointsFortsScolaires?: { meilleuresMatieres: Array<string | null>, correspondentAuxMatieresPreferees: string } | null, agroSectorActivity1?: { mots?: Array<string | null> | null } | null, agroSectorActivity3?: { continueStudiesOrProLife?: string | null, whatDoIlikeMostAfterBac?: Array<string | null> | null, whatDoIlikeMostContinueStudies?: Array<string | null> | null } | null, softSkillEvaluations?: Array<{ key?: string | null, value?: string | null } | null> | null, formationComparaisons?: Array<{ pisteId: string, duree?: string | null, cout?: string | null, experiencePro?: Array<string | null> | null, debouches?: string | null, correspond?: string | null, correspondpas?: string | null, order?: number | null } | null> | null, bilansModules?: Array<{ moduleId?: string | null, questions?: Array<{ id?: string | null, answer?: number | null } | null> | null } | null> | null, matieres?: Array<{ matiere?: string | null, grade?: number | null, like?: number | null } | null> | null, environnement?: Array<{ type: string, interest: number } | null> | null } | null, algoResults?: Array<{ pisteId: string, score: number, name: string } | null> | null } | null };

export type ElevesActivitesBacProQueryVariables = Exact<{ [key: string]: never; }>;


export type ElevesActivitesBacProQuery = { currentClasse?: { _id?: string | null, eleves?: Array<{ _id: string, profile?: { firstName?: string | null, lastName?: string | null } | null, activitesBacPro?: Array<{ activiteId?: string | null, status?: string | null } | null> | null } | null> | null } | null };

export type JobreadyTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type JobreadyTokenMutation = { jobreadyToken?: string | null };

export type LyceenQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type LyceenQuery = { eleve?: { profile?: { firstName?: string | null, lastName?: string | null, age?: number | null, filiere?: string | null, filiereTechno?: string | null, filiereBacPro?: string | null, niveau?: string | null, spes_premiere?: Array<string | null> | null, spes_terminale?: Array<string | null> | null, spe_abandonnee_premiere?: Array<string | null> | null, lycee?: string | null, lyceeCity?: string | null, departement?: string | null, matieres?: Array<{ matiere?: string | null, grade?: number | null, like?: number | null } | null> | null } | null, algoResults?: Array<{ pisteId: string, score: number, name: string } | null> | null } | null };

export type MyBacProActivitesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyBacProActivitesQuery = { myUser?: { activitesBacPro?: Array<{ activiteId?: string | null, status?: string | null } | null> | null } | null };

export type MyProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type MyProfileQuery = { myUser?: { _id: string, isProfileComplete?: boolean | null, isQuestionnaireComplete?: boolean | null, ssoId?: string | null, createdAt?: any | null, profile?: { title?: string | null, fonction?: string | null, fonctionAutre?: string | null, firstName?: string | null, lastName?: string | null, departement?: string | null, birthDate?: any | null, lyceeId?: string | null, lyceeCity?: string | null, lycee?: string | null, gender?: string | null, referredBy?: string | null, algoResultsRating?: number | null, region?: string | null, codePostal?: string | null, diplomes?: Array<string | null> | null, difficulteTrouverStage?: number | null, ressentiFormation?: number | null, motivation?: Array<string | null> | null, hadInspirePresentation?: boolean | null, previsionOccupationPostBac?: string | null, previsionAnneesEtudesPostBac?: number | null, previsionQuitterDomicileParental?: boolean | null, previsionEloignementDomicileParental?: string | null, previsionTempsMaxTrajetParJour?: string | null, previsionTypeTransport?: Array<string | null> | null, connaitCoutEtudes?: number | null, financementEtudesFrein?: number | null, isBoursierSecondaire?: string | null, connaitPersonnesMemeDomaine?: number | null, prevoitCreerEntreprise?: boolean | null, mesQualites?: Array<string | null> | null, qualitesAmeliorer?: Array<string | null> | null, howToImproveQualite?: string | null, etapesProjet?: Array<string | null> | null, softSkillsExperience?: string | null, softSkillsList?: Array<string | null> | null, softSkillsDifficultes?: Array<string | null> | null, softSkillsActions?: string | null, softSkillsRessenti?: Array<string | null> | null, softSkillsAmeliorations?: string | null, competencesActivite?: string | null, competencesList?: Array<string | null> | null, pedagogie_filiere_generale?: boolean | null, pedagogie_filiere_professionnelle?: boolean | null, pedagogie_filiere_technologique?: boolean | null, planActionObjectif?: string | null, planActionTemps?: string | null, planActionEntreprendre?: string | null, planActionComplementaire?: string | null, stageDuree?: string | null, stageSecteurActivite?: string | null, stageMetier?: string | null, stageGeographie?: string | null, stageMissions?: string | null, stageTypeEntreprise?: string | null, stageMotsCles?: string | null, stageSite?: string | null, checklistCV?: Array<string | null> | null, checklistLM?: Array<string | null> | null, analyseOffreEmploi?: Array<string | null> | null, stageEntrepriseActivite?: string | null, stageEntrepriseSoftSkills?: string | null, creationEntrepriseOpinion?: Array<string | null> | null, demenagement?: string | null, typeLogement?: Array<string | null> | null, gererBudget?: string | null, rencontrerDuMonde?: Array<string | null> | null, formationRoute?: string | null, preferenceFormatClasse?: string | null, preferenceEncadrement?: string | null, preferenceRevisions?: string | null, preferenceEmploiDuTemps?: string | null, formationMotiveContexte?: string | null, formationMotiveDemarches?: string | null, formationMotiveApports?: string | null, formationMotiveCadre?: string | null, formationMotiveAtouts?: string | null, formationMotiveQualites?: string | null, preferencesApprentissage?: Array<string | null> | null, prioritesAvenir?: Array<string | null> | null, matieresPreferes?: Array<string | null> | null, meConnaitreQualites?: Array<string | null> | null, adequationMetierOuSecteurReve?: string | null, adequationCentresInteretsPriorites?: string | null, adequationQualites?: string | null, experienceStage?: string | null, stageCapacitesSociales?: string | null, stageCapacitesPersonnelles?: string | null, stageCapacitesMethodologiques?: string | null, softSkillsPlanAction?: string | null, derniereExperienceStage?: string | null, capacitesSocialesStage?: Array<string | null> | null, capacitesPersonnellesStage?: Array<string | null> | null, capacitesMethodologiquesStage?: Array<string | null> | null, capacitesSocialesADevelopper?: Array<string | null> | null, capacitesPersonnellesADevelopper?: Array<string | null> | null, capacitesMethodologiquesADevelopper?: Array<string | null> | null, motivationsEtudes?: string | null, motivationsTravail?: string | null, actionsEtudes?: string | null, imagineDans5ans?: string | null, imageValeur?: string | null, motsclesValeur?: Array<string | null> | null, mesQuestionnements?: Array<string | null> | null, aspirationsMetiersQuiInteressaient?: string | null, aspirationsMetiersQuiInteressent?: string | null, aspirationsCentresInterets?: string | null, aspirationsCeEnQuoiJeSuisFort?: string | null, aspirationsOntEvolue?: string | null, aspirationsPointsCommunsMetiersValeurs?: string | null, aspirationsForcesUtiles?: string | null, aspirationsPointsCommunsMetiersCentresInterets?: string | null, secteursInterets?: Array<string | null> | null, secteursCompetencesTransversales?: string | null, secteursCompetencesADevelopper?: string | null, formationChoixPiste?: string | null, formationEtablissements?: string | null, formationSelective?: string | null, formationPointsForts?: Array<string | null> | null, formationMoyenne?: number | null, formationMatiereBonsResultats?: string | null, formationSavoirsEtre?: string | null, formationEvaluationMotivation?: string | null, formationCompetencesTransversales?: string | null, formationMesPointsForts?: string | null, formationMesPointsAmelioration?: string | null, formationMesExperiencesUtiles?: string | null, vieEtudianteDemenager?: string | null, vieEtudianteTypeLogement?: string | null, vieEtudianteAideDemenagement?: string | null, vieEtudianteFinancement?: string | null, vieEtudianteQuestionsAuxEclaireurs?: string | null, age?: number | null, tagline?: string | null, studiesFirstYear?: number | null, speBac?: string | null, knewNobodyBacP1?: boolean | null, livedWithFamilyBacP1?: boolean | null, studiedAbroad?: boolean | null, apprentissage?: boolean | null, logementEtudiant?: boolean | null, sourceOfFinanceStudies?: Array<string | null> | null, willReviewCV?: boolean | null, niveau?: string | null, isNiveauConfirmed?: boolean | null, filiere?: string | null, filiereTechno?: string | null, filiereBacPro?: string | null, picture?: string | null, boursierLycee?: string | null, spes_premiere?: Array<string | null> | null, spes_terminale?: Array<string | null> | null, spe_abandonnee_premiere?: Array<string | null> | null, hasOptions?: boolean | null, options_terminale?: Array<string | null> | null, moyennePremiere?: number | null, encadrement?: string | null, boostAlternanceApprentissage?: number | null, boostPartir?: number | null, boostConnaisPersonne?: number | null, boostBudget?: number | null, inscriptionPedagogique?: boolean | null, isLyceenPrioritaire?: boolean | null, newsletter?: boolean | null, update_newsletter?: any | null, partnership?: string | null, obendyWidgetUrl?: string | null, obendyPixelAnalyticsUrl?: string | null, matieres?: Array<{ matiere?: string | null, like?: number | null, grade?: number | null } | null> | null, debouches?: Array<{ key: string, value?: number | null } | null> | null, avenirPro?: Array<{ key: string, value?: number | null } | null> | null, attitudes?: Array<{ key: string, value?: number | null } | null> | null, favoritePistes?: Array<{ id: string } | null> | null, favoriteEclaireurs?: Array<{ _id: string } | null> | null, centresDinterets?: { centresDinterets: Array<string | null>, sport?: string | null, danse?: string | null, autre?: string | null } | null, metierOuSecteurReve?: { saitMetierOuSecteur: boolean, metierOuSecteur?: string | null, pourraitInteresser?: Array<string | null> | null } | null, choixFormation?: { choisiFormation: string, pourquoiChoisi?: string | null, interessant?: string | null } | null, adequationPreferencesApprentissage?: { correspond: string, pourquoiNon?: string | null } | null, pointsFortsScolaires?: { meilleuresMatieres: Array<string | null>, correspondentAuxMatieresPreferees: string } | null, agroSectorActivity1?: { mots?: Array<string | null> | null } | null, agroSectorActivity3?: { continueStudiesOrProLife?: string | null, whatDoIlikeMostAfterBac?: Array<string | null> | null, whatDoIlikeMostContinueStudies?: Array<string | null> | null } | null, lettreDeMotiv?: Array<{ key?: string | null, value?: string | null } | null> | null, etapesEntreprise?: Array<{ key: string, value?: number | null } | null> | null, pistesOpinions?: Array<{ pisteName: string, pisteId: string, like?: string | null, dislike?: string | null } | null> | null, entretienFeedback?: Array<{ key?: string | null, value?: string | null } | null> | null, softSkillEvaluations?: Array<{ key?: string | null, value?: string | null } | null> | null, formationComparaisons?: Array<{ pisteId: string, duree?: string | null, cout?: string | null, experiencePro?: Array<string | null> | null, debouches?: string | null, correspond?: string | null, correspondpas?: string | null, order?: number | null } | null> | null, bilansModules?: Array<{ moduleId?: string | null, questions?: Array<{ id?: string | null, answer?: number | null } | null> | null } | null> | null, studies?: Array<{ year?: number | null, formation?: string | null, formationId?: string | null, etablissement?: string | null, etablissementId?: string | null, formationYear?: number | null, departement?: string | null, ville?: string | null, pays?: string | null, codePostal?: string | null, skippingYear?: boolean | null, skippingYearOccupation?: Array<string | null> | null, skippingYearOther?: string | null, option?: string | null, optionAutre?: string | null, optionMentionCMI?: string | null, secondFormation?: { departement?: string | null, etablissement?: string | null, etablissementId?: string | null, formation?: string | null, formationId?: string | null, formationYear?: number | null, doubleDegree?: boolean | null, ville?: string | null, pays?: string | null, codePostal?: string | null, option?: string | null } | null } | null> | null, eclaireurQuestions?: Array<{ key?: string | null, value?: string | null } | null> | null, lyceeStudies?: Array<{ annee: number, filiere?: string | null, niveau: string, filiereBacPro?: string | null } | null> | null, domains?: Array<{ domain?: string | null, interest?: number | null } | null> | null, environnement?: Array<{ type: string, interest: number } | null> | null, prochainesEtapes?: Array<{ name?: string | null, status?: string | null } | null> | null, notifications?: { media?: { sms?: boolean | null, email?: boolean | null, onsite?: boolean | null } | null } | null } | null, emails?: Array<{ address: string, verified: boolean } | null> | null, pistes?: Array<{ _id?: string | null, name?: string | null, slug?: string | null, coverPicture?: string | null, typeFormation?: Array<string | null> | null } | null> | null, algoResults?: Array<{ pisteId: string, name: string, score: number, rating?: number | null } | null> | null, phoneNumber?: { number?: string | null, verified?: boolean | null } | null } | null };

export type ProfByEmailQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type ProfByEmailQuery = { profByEmail?: { _id: string, profile?: { firstName?: string | null, lastName?: string | null } | null } | null };

export type RateAlgoResultMutationVariables = Exact<{
  pisteId: Scalars['ID'];
  rating: Scalars['Int'];
}>;


export type RateAlgoResultMutation = { rateAlgoResult?: any | null };

export type RemoveProfMutationVariables = Exact<{
  classeId: Scalars['ID'];
  profId: Scalars['ID'];
}>;


export type RemoveProfMutation = { removeProf?: any | null };

export type ResetDemoMutationVariables = Exact<{ [key: string]: never; }>;


export type ResetDemoMutation = { resetDemo?: any | null };

export type SetActiviteBacProMutationVariables = Exact<{
  activiteId: Scalars['ID'];
  status: Scalars['String'];
  moduleActivites?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SetActiviteBacProMutation = { setActiviteBacPro?: any | null };

export type SetBilanModuleMutationVariables = Exact<{
  moduleId: Scalars['ID'];
  questions: Array<InputMaybe<BilanModuleQuestionInput>> | InputMaybe<BilanModuleQuestionInput>;
}>;


export type SetBilanModuleMutation = { setBilanModule?: any | null };

export type SetEclaireurMobiliteGroupMutationVariables = Exact<{
  hasBeenClicked: Scalars['Boolean'];
}>;


export type SetEclaireurMobiliteGroupMutation = { setEclaireurMobiliteGroup?: any | null };

export type SetLyceeStudyYearMutationVariables = Exact<{
  niveau: Scalars['String'];
  filiere?: InputMaybe<Scalars['String']>;
  filiereTechno?: InputMaybe<Scalars['String']>;
  filiereBacPro?: InputMaybe<Scalars['String']>;
}>;


export type SetLyceeStudyYearMutation = { setLyceeStudyYear?: any | null };

export type SetMyProfileMutationVariables = Exact<{
  input: UserProfileInput;
}>;


export type SetMyProfileMutation = { setMyProfile?: any | null };

export type SetPhoneNumberMutationVariables = Exact<{
  numberToVerify: Scalars['String'];
  tokenToVerify?: InputMaybe<Scalars['String']>;
}>;


export type SetPhoneNumberMutation = { setPhoneNumber?: any | null };

export type SetStateOfMindMutationVariables = Exact<{
  input: StateOfMindInput;
}>;


export type SetStateOfMindMutation = { setStateOfMind?: any | null };

export type SetStudyYearMutationVariables = Exact<{
  studyYear: StudyYearInput;
}>;


export type SetStudyYearMutation = { setStudyYear?: any | null };

export type StateOfMindQueryVariables = Exact<{ [key: string]: never; }>;


export type StateOfMindQuery = { myUser?: { stateOfMind?: { seLancerDansEtudesSup?: string | null, souhaiteAccompagnement?: boolean | null } | null } | null };

export type TriggerAlgoMutationVariables = Exact<{
  classeHasModules: Scalars['Boolean'];
}>;


export type TriggerAlgoMutation = { triggerAlgo?: any | null };

export type IsHorsScopeQueryVariables = Exact<{ [key: string]: never; }>;


export type IsHorsScopeQuery = { isHorsScope?: boolean | null };


export const CreateEclaireurDocument = `
    mutation CreateEclaireur($profile: UserProfileInput!) {
  createEclaireur(profile: $profile) {
    id
    token
    tokenExpires
    ssoId
  }
}
    `;
export const useCreateEclaireurMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateEclaireurMutation, TError, CreateEclaireurMutationVariables, TContext>) =>
    useMutation<CreateEclaireurMutation, TError, CreateEclaireurMutationVariables, TContext>(
      ['CreateEclaireur'],
      (variables?: CreateEclaireurMutationVariables) => gqlRequest<CreateEclaireurMutation, CreateEclaireurMutationVariables>(CreateEclaireurDocument, variables)(),
      options
    );
export const CreateLyceenDocument = `
    mutation CreateLyceen($profile: UserProfileInput!, $signupToken: String) {
  createLyceen(profile: $profile, signupToken: $signupToken) {
    id
    token
    tokenExpires
    ssoId
  }
}
    `;
export const useCreateLyceenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLyceenMutation, TError, CreateLyceenMutationVariables, TContext>) =>
    useMutation<CreateLyceenMutation, TError, CreateLyceenMutationVariables, TContext>(
      ['CreateLyceen'],
      (variables?: CreateLyceenMutationVariables) => gqlRequest<CreateLyceenMutation, CreateLyceenMutationVariables>(CreateLyceenDocument, variables)(),
      options
    );
export const CreateLyceenHorsScopeDocument = `
    mutation CreateLyceenHorsScope($niveau: String!) {
  createLyceenHorsScope(niveau: $niveau)
}
    `;
export const useCreateLyceenHorsScopeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateLyceenHorsScopeMutation, TError, CreateLyceenHorsScopeMutationVariables, TContext>) =>
    useMutation<CreateLyceenHorsScopeMutation, TError, CreateLyceenHorsScopeMutationVariables, TContext>(
      ['CreateLyceenHorsScope'],
      (variables?: CreateLyceenHorsScopeMutationVariables) => gqlRequest<CreateLyceenHorsScopeMutation, CreateLyceenHorsScopeMutationVariables>(CreateLyceenHorsScopeDocument, variables)(),
      options
    );
export const CreateProfDocument = `
    mutation CreateProf($profile: UserProfileInput!) {
  createProf(profile: $profile) {
    id
    token
    tokenExpires
    ssoId
  }
}
    `;
export const useCreateProfMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateProfMutation, TError, CreateProfMutationVariables, TContext>) =>
    useMutation<CreateProfMutation, TError, CreateProfMutationVariables, TContext>(
      ['CreateProf'],
      (variables?: CreateProfMutationVariables) => gqlRequest<CreateProfMutation, CreateProfMutationVariables>(CreateProfDocument, variables)(),
      options
    );
export const DeleteMyAccountDocument = `
    mutation DeleteMyAccount {
  deleteMyAccount
}
    `;
export const useDeleteMyAccountMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteMyAccountMutation, TError, DeleteMyAccountMutationVariables, TContext>) =>
    useMutation<DeleteMyAccountMutation, TError, DeleteMyAccountMutationVariables, TContext>(
      ['DeleteMyAccount'],
      (variables?: DeleteMyAccountMutationVariables) => gqlRequest<DeleteMyAccountMutation, DeleteMyAccountMutationVariables>(DeleteMyAccountDocument, variables)(),
      options
    );
export const ForgotPasswordDocument = `
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email) {
    success
  }
}
    `;
export const useForgotPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ForgotPasswordMutation, TError, ForgotPasswordMutationVariables, TContext>) =>
    useMutation<ForgotPasswordMutation, TError, ForgotPasswordMutationVariables, TContext>(
      ['ForgotPassword'],
      (variables?: ForgotPasswordMutationVariables) => gqlRequest<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, variables)(),
      options
    );
export const ResendVerificationEmailDocument = `
    mutation ResendVerificationEmail {
  resendVerificationEmail {
    success
  }
}
    `;
export const useResendVerificationEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResendVerificationEmailMutation, TError, ResendVerificationEmailMutationVariables, TContext>) =>
    useMutation<ResendVerificationEmailMutation, TError, ResendVerificationEmailMutationVariables, TContext>(
      ['ResendVerificationEmail'],
      (variables?: ResendVerificationEmailMutationVariables) => gqlRequest<ResendVerificationEmailMutation, ResendVerificationEmailMutationVariables>(ResendVerificationEmailDocument, variables)(),
      options
    );
export const ResetPasswordDocument = `
    mutation ResetPassword($newPassword: HashedPassword!, $token: String!) {
  resetPassword(newPassword: $newPassword, token: $token) {
    id
  }
}
    `;
export const useResetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>) =>
    useMutation<ResetPasswordMutation, TError, ResetPasswordMutationVariables, TContext>(
      ['ResetPassword'],
      (variables?: ResetPasswordMutationVariables) => gqlRequest<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, variables)(),
      options
    );
export const VerifyEmailDocument = `
    mutation VerifyEmail($token: String!) {
  verifyEmail(token: $token) {
    id
    token
    tokenExpires
  }
}
    `;
export const useVerifyEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<VerifyEmailMutation, TError, VerifyEmailMutationVariables, TContext>) =>
    useMutation<VerifyEmailMutation, TError, VerifyEmailMutationVariables, TContext>(
      ['VerifyEmail'],
      (variables?: VerifyEmailMutationVariables) => gqlRequest<VerifyEmailMutation, VerifyEmailMutationVariables>(VerifyEmailDocument, variables)(),
      options
    );
export const ArticlesDocument = `
    query Articles($filters: ArticleQueryInput, $limit: Int, $skip: Int, $tag: String) {
  articles(filters: $filters, limit: $limit, skip: $skip, tag: $tag) {
    _id
    title
    slug
    coverPicture
    createdAt
    tags
    tag
    chapo
    subtag
    excerpt
  }
}
    `;
export const useArticlesQuery = <
      TData = ArticlesQuery,
      TError = unknown
    >(
      variables?: ArticlesQueryVariables,
      options?: UseQueryOptions<ArticlesQuery, TError, TData>
    ) =>
    useQuery<ArticlesQuery, TError, TData>(
      variables === undefined ? ['Articles'] : ['Articles', variables],
      gqlRequest<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, variables),
      options
    );
export const useInfiniteArticlesQuery = <
      TData = ArticlesQuery,
      TError = unknown
    >(
      variables?: ArticlesQueryVariables,
      options?: UseInfiniteQueryOptions<ArticlesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ArticlesQuery, TError, TData>(
      variables === undefined ? ['Articles.infinite'] : ['Articles.infinite', variables],
      (metaData) => gqlRequest<ArticlesQuery, ArticlesQueryVariables>(ArticlesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CreateContactRequestDocument = `
    mutation CreateContactRequest($requestFor: ID!, $group: String) {
  createContactRequest(requestFor: $requestFor, group: $group)
}
    `;
export const useCreateContactRequestMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateContactRequestMutation, TError, CreateContactRequestMutationVariables, TContext>) =>
    useMutation<CreateContactRequestMutation, TError, CreateContactRequestMutationVariables, TContext>(
      ['CreateContactRequest'],
      (variables?: CreateContactRequestMutationVariables) => gqlRequest<CreateContactRequestMutation, CreateContactRequestMutationVariables>(CreateContactRequestDocument, variables)(),
      options
    );
export const MarkThreadAsSeenDocument = `
    mutation MarkThreadAsSeen($threadId: String!) {
  markThreadAsSeen(threadId: $threadId)
}
    `;
export const useMarkThreadAsSeenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<MarkThreadAsSeenMutation, TError, MarkThreadAsSeenMutationVariables, TContext>) =>
    useMutation<MarkThreadAsSeenMutation, TError, MarkThreadAsSeenMutationVariables, TContext>(
      ['MarkThreadAsSeen'],
      (variables?: MarkThreadAsSeenMutationVariables) => gqlRequest<MarkThreadAsSeenMutation, MarkThreadAsSeenMutationVariables>(MarkThreadAsSeenDocument, variables)(),
      options
    );
export const MyContactRequestsDocument = `
    query MyContactRequests($threadId: String, $limit: Int, $skip: Int) {
  myContactRequests(threadId: $threadId, limit: $limit, skip: $skip) {
    _id
    requestBy
    requestFor
    updatedAt
    hasNewMessage
    problemLyceen
    problemEclaireur
    contactInfo {
      _id
      firstName
      pisteIds
      pistes {
        name
      }
      picture
      age
      role
      niveau
      filiere
      filiereTechno
      filiereBacPro
    }
    exchangeStats {
      lastMessageDate
    }
    hasSentIntroMessage
  }
}
    `;
export const useMyContactRequestsQuery = <
      TData = MyContactRequestsQuery,
      TError = unknown
    >(
      variables?: MyContactRequestsQueryVariables,
      options?: UseQueryOptions<MyContactRequestsQuery, TError, TData>
    ) =>
    useQuery<MyContactRequestsQuery, TError, TData>(
      variables === undefined ? ['MyContactRequests'] : ['MyContactRequests', variables],
      gqlRequest<MyContactRequestsQuery, MyContactRequestsQueryVariables>(MyContactRequestsDocument, variables),
      options
    );
export const useInfiniteMyContactRequestsQuery = <
      TData = MyContactRequestsQuery,
      TError = unknown
    >(
      variables?: MyContactRequestsQueryVariables,
      options?: UseInfiniteQueryOptions<MyContactRequestsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<MyContactRequestsQuery, TError, TData>(
      variables === undefined ? ['MyContactRequests.infinite'] : ['MyContactRequests.infinite', variables],
      (metaData) => gqlRequest<MyContactRequestsQuery, MyContactRequestsQueryVariables>(MyContactRequestsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const SendMessageDocument = `
    mutation SendMessage($threadId: String!, $content: String!, $introQuestionKey: String, $introQuestionCategory: String) {
  sendMessage(
    threadId: $threadId
    content: $content
    introQuestionKey: $introQuestionKey
    introQuestionCategory: $introQuestionCategory
  )
}
    `;
export const useSendMessageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SendMessageMutation, TError, SendMessageMutationVariables, TContext>) =>
    useMutation<SendMessageMutation, TError, SendMessageMutationVariables, TContext>(
      ['SendMessage'],
      (variables?: SendMessageMutationVariables) => gqlRequest<SendMessageMutation, SendMessageMutationVariables>(SendMessageDocument, variables)(),
      options
    );
export const SignalProblemDocument = `
    mutation SignalProblem($threadId: String!, $problem: String!) {
  signalProblem(threadId: $threadId, problem: $problem)
}
    `;
export const useSignalProblemMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SignalProblemMutation, TError, SignalProblemMutationVariables, TContext>) =>
    useMutation<SignalProblemMutation, TError, SignalProblemMutationVariables, TContext>(
      ['SignalProblem'],
      (variables?: SignalProblemMutationVariables) => gqlRequest<SignalProblemMutation, SignalProblemMutationVariables>(SignalProblemDocument, variables)(),
      options
    );
export const ChatThreadByIdDocument = `
    query ChatThreadById($threadId: String!, $limit: Int, $skip: Int) {
  messagesByThreadId(threadId: $threadId, limit: $limit, skip: $skip) {
    _id
    threadId
    sender
    recipients
    content
    timestamp
    type
    introQuestionKey
    introQuestionCategory
  }
}
    `;
export const useChatThreadByIdQuery = <
      TData = ChatThreadByIdQuery,
      TError = unknown
    >(
      variables: ChatThreadByIdQueryVariables,
      options?: UseQueryOptions<ChatThreadByIdQuery, TError, TData>
    ) =>
    useQuery<ChatThreadByIdQuery, TError, TData>(
      ['ChatThreadById', variables],
      gqlRequest<ChatThreadByIdQuery, ChatThreadByIdQueryVariables>(ChatThreadByIdDocument, variables),
      options
    );
export const useInfiniteChatThreadByIdQuery = <
      TData = ChatThreadByIdQuery,
      TError = unknown
    >(
      variables: ChatThreadByIdQueryVariables,
      options?: UseInfiniteQueryOptions<ChatThreadByIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ChatThreadByIdQuery, TError, TData>(
      ['ChatThreadById.infinite', variables],
      (metaData) => gqlRequest<ChatThreadByIdQuery, ChatThreadByIdQueryVariables>(ChatThreadByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const AllClassesDocument = `
    query AllClasses {
  allClasses {
    _id
    classeName
    modulesCounter
  }
}
    `;
export const useAllClassesQuery = <
      TData = AllClassesQuery,
      TError = unknown
    >(
      variables?: AllClassesQueryVariables,
      options?: UseQueryOptions<AllClassesQuery, TError, TData>
    ) =>
    useQuery<AllClassesQuery, TError, TData>(
      variables === undefined ? ['AllClasses'] : ['AllClasses', variables],
      gqlRequest<AllClassesQuery, AllClassesQueryVariables>(AllClassesDocument, variables),
      options
    );
export const useInfiniteAllClassesQuery = <
      TData = AllClassesQuery,
      TError = unknown
    >(
      variables?: AllClassesQueryVariables,
      options?: UseInfiniteQueryOptions<AllClassesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<AllClassesQuery, TError, TData>(
      variables === undefined ? ['AllClasses.infinite'] : ['AllClasses.infinite', variables],
      (metaData) => gqlRequest<AllClassesQuery, AllClassesQueryVariables>(AllClassesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ChangeCurrentClasseDocument = `
    mutation ChangeCurrentClasse($id: ID!) {
  changeCurrentClasse(id: $id)
}
    `;
export const useChangeCurrentClasseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ChangeCurrentClasseMutation, TError, ChangeCurrentClasseMutationVariables, TContext>) =>
    useMutation<ChangeCurrentClasseMutation, TError, ChangeCurrentClasseMutationVariables, TContext>(
      ['ChangeCurrentClasse'],
      (variables?: ChangeCurrentClasseMutationVariables) => gqlRequest<ChangeCurrentClasseMutation, ChangeCurrentClasseMutationVariables>(ChangeCurrentClasseDocument, variables)(),
      options
    );
export const ClasseByIdDocument = `
    query ClasseById($id: ID!) {
  classeById(id: $id) {
    _id
    classeName
    niveau
    familleMetiers
    filiere
    filiereBacPro
    filiereTechno
    signupToken
    anneeScolaire
    lyceeId
    eleves {
      _id
      profile {
        firstName
        lastName
      }
    }
  }
}
    `;
export const useClasseByIdQuery = <
      TData = ClasseByIdQuery,
      TError = unknown
    >(
      variables: ClasseByIdQueryVariables,
      options?: UseQueryOptions<ClasseByIdQuery, TError, TData>
    ) =>
    useQuery<ClasseByIdQuery, TError, TData>(
      ['ClasseById', variables],
      gqlRequest<ClasseByIdQuery, ClasseByIdQueryVariables>(ClasseByIdDocument, variables),
      options
    );
export const useInfiniteClasseByIdQuery = <
      TData = ClasseByIdQuery,
      TError = unknown
    >(
      variables: ClasseByIdQueryVariables,
      options?: UseInfiniteQueryOptions<ClasseByIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ClasseByIdQuery, TError, TData>(
      ['ClasseById.infinite', variables],
      (metaData) => gqlRequest<ClasseByIdQuery, ClasseByIdQueryVariables>(ClasseByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ClasseByTokenDocument = `
    query ClasseByToken($signupToken: String!) {
  classeByToken(signupToken: $signupToken) {
    _id
    niveau
    filiere
    familleMetiers
    filiereBacPro
    filiereTechno
    classeName
    profs {
      profile {
        title
        firstName
        lastName
      }
    }
    lycee {
      nom
      ville
    }
  }
}
    `;
export const useClasseByTokenQuery = <
      TData = ClasseByTokenQuery,
      TError = unknown
    >(
      variables: ClasseByTokenQueryVariables,
      options?: UseQueryOptions<ClasseByTokenQuery, TError, TData>
    ) =>
    useQuery<ClasseByTokenQuery, TError, TData>(
      ['ClasseByToken', variables],
      gqlRequest<ClasseByTokenQuery, ClasseByTokenQueryVariables>(ClasseByTokenDocument, variables),
      options
    );
export const useInfiniteClasseByTokenQuery = <
      TData = ClasseByTokenQuery,
      TError = unknown
    >(
      variables: ClasseByTokenQueryVariables,
      options?: UseInfiniteQueryOptions<ClasseByTokenQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ClasseByTokenQuery, TError, TData>(
      ['ClasseByToken.infinite', variables],
      (metaData) => gqlRequest<ClasseByTokenQuery, ClasseByTokenQueryVariables>(ClasseByTokenDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ClasseProfsDocument = `
    query ClasseProfs($classeId: ID!) {
  classeById(id: $classeId) {
    profs {
      _id
      profile {
        firstName
        lastName
      }
    }
  }
}
    `;
export const useClasseProfsQuery = <
      TData = ClasseProfsQuery,
      TError = unknown
    >(
      variables: ClasseProfsQueryVariables,
      options?: UseQueryOptions<ClasseProfsQuery, TError, TData>
    ) =>
    useQuery<ClasseProfsQuery, TError, TData>(
      ['ClasseProfs', variables],
      gqlRequest<ClasseProfsQuery, ClasseProfsQueryVariables>(ClasseProfsDocument, variables),
      options
    );
export const useInfiniteClasseProfsQuery = <
      TData = ClasseProfsQuery,
      TError = unknown
    >(
      variables: ClasseProfsQueryVariables,
      options?: UseInfiniteQueryOptions<ClasseProfsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ClasseProfsQuery, TError, TData>(
      ['ClasseProfs.infinite', variables],
      (metaData) => gqlRequest<ClasseProfsQuery, ClasseProfsQueryVariables>(ClasseProfsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CreateClasseDocument = `
    mutation CreateClasse($input: ClasseInput!) {
  createClasse(input: $input)
}
    `;
export const useCreateClasseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateClasseMutation, TError, CreateClasseMutationVariables, TContext>) =>
    useMutation<CreateClasseMutation, TError, CreateClasseMutationVariables, TContext>(
      ['CreateClasse'],
      (variables?: CreateClasseMutationVariables) => gqlRequest<CreateClasseMutation, CreateClasseMutationVariables>(CreateClasseDocument, variables)(),
      options
    );
export const CurrentClasseForLyceenDocument = `
    query CurrentClasseForLyceen {
  currentClasse {
    _id
    classeName
    niveau
    filiere
    filiereBacPro
    filiereTechno
    familleMetiers
    anneeScolaire
    lyceeId
    lycee {
      nom
      ville
      departement
      departementCode
      academie
      isPrioritaire
    }
    modules {
      moduleId
      disabled
      disabledActivites
    }
  }
}
    `;
export const useCurrentClasseForLyceenQuery = <
      TData = CurrentClasseForLyceenQuery,
      TError = unknown
    >(
      variables?: CurrentClasseForLyceenQueryVariables,
      options?: UseQueryOptions<CurrentClasseForLyceenQuery, TError, TData>
    ) =>
    useQuery<CurrentClasseForLyceenQuery, TError, TData>(
      variables === undefined ? ['CurrentClasseForLyceen'] : ['CurrentClasseForLyceen', variables],
      gqlRequest<CurrentClasseForLyceenQuery, CurrentClasseForLyceenQueryVariables>(CurrentClasseForLyceenDocument, variables),
      options
    );
export const useInfiniteCurrentClasseForLyceenQuery = <
      TData = CurrentClasseForLyceenQuery,
      TError = unknown
    >(
      variables?: CurrentClasseForLyceenQueryVariables,
      options?: UseInfiniteQueryOptions<CurrentClasseForLyceenQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CurrentClasseForLyceenQuery, TError, TData>(
      variables === undefined ? ['CurrentClasseForLyceen.infinite'] : ['CurrentClasseForLyceen.infinite', variables],
      (metaData) => gqlRequest<CurrentClasseForLyceenQuery, CurrentClasseForLyceenQueryVariables>(CurrentClasseForLyceenDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const CurrentClasseForProfDocument = `
    query CurrentClasseForProf {
  currentClasse {
    _id
    classeName
    niveau
    familleMetiers
    filiere
    filiereBacPro
    filiereTechno
    signupToken
    anneeScolaire
    lyceeId
    pays
    lyceeEtrangerName
    eleves {
      _id
      profile {
        firstName
        lastName
      }
    }
    modules {
      moduleId
      disabled
      disabledActivites
    }
    lycee {
      nom
      ville
      departement
      departementCode
      academie
      isPrioritaire
    }
  }
}
    `;
export const useCurrentClasseForProfQuery = <
      TData = CurrentClasseForProfQuery,
      TError = unknown
    >(
      variables?: CurrentClasseForProfQueryVariables,
      options?: UseQueryOptions<CurrentClasseForProfQuery, TError, TData>
    ) =>
    useQuery<CurrentClasseForProfQuery, TError, TData>(
      variables === undefined ? ['CurrentClasseForProf'] : ['CurrentClasseForProf', variables],
      gqlRequest<CurrentClasseForProfQuery, CurrentClasseForProfQueryVariables>(CurrentClasseForProfDocument, variables),
      options
    );
export const useInfiniteCurrentClasseForProfQuery = <
      TData = CurrentClasseForProfQuery,
      TError = unknown
    >(
      variables?: CurrentClasseForProfQueryVariables,
      options?: UseInfiniteQueryOptions<CurrentClasseForProfQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CurrentClasseForProfQuery, TError, TData>(
      variables === undefined ? ['CurrentClasseForProf.infinite'] : ['CurrentClasseForProf.infinite', variables],
      (metaData) => gqlRequest<CurrentClasseForProfQuery, CurrentClasseForProfQueryVariables>(CurrentClasseForProfDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DeleteClasseDocument = `
    mutation DeleteClasse($id: ID!) {
  deleteClasse(id: $id)
}
    `;
export const useDeleteClasseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteClasseMutation, TError, DeleteClasseMutationVariables, TContext>) =>
    useMutation<DeleteClasseMutation, TError, DeleteClasseMutationVariables, TContext>(
      ['DeleteClasse'],
      (variables?: DeleteClasseMutationVariables) => gqlRequest<DeleteClasseMutation, DeleteClasseMutationVariables>(DeleteClasseDocument, variables)(),
      options
    );
export const GenerateTokenDocument = `
    mutation GenerateToken($classeId: ID!) {
  generateToken(classeId: $classeId)
}
    `;
export const useGenerateTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GenerateTokenMutation, TError, GenerateTokenMutationVariables, TContext>) =>
    useMutation<GenerateTokenMutation, TError, GenerateTokenMutationVariables, TContext>(
      ['GenerateToken'],
      (variables?: GenerateTokenMutationVariables) => gqlRequest<GenerateTokenMutation, GenerateTokenMutationVariables>(GenerateTokenDocument, variables)(),
      options
    );
export const ImportElevesDocument = `
    mutation ImportEleves($classeId: ID!, $eleveIds: [ID!]!) {
  importEleves(classeId: $classeId, eleveIds: $eleveIds)
}
    `;
export const useImportElevesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ImportElevesMutation, TError, ImportElevesMutationVariables, TContext>) =>
    useMutation<ImportElevesMutation, TError, ImportElevesMutationVariables, TContext>(
      ['ImportEleves'],
      (variables?: ImportElevesMutationVariables) => gqlRequest<ImportElevesMutation, ImportElevesMutationVariables>(ImportElevesDocument, variables)(),
      options
    );
export const JoinClasseDocument = `
    mutation JoinClasse($token: String!) {
  joinClasse(token: $token)
}
    `;
export const useJoinClasseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JoinClasseMutation, TError, JoinClasseMutationVariables, TContext>) =>
    useMutation<JoinClasseMutation, TError, JoinClasseMutationVariables, TContext>(
      ['JoinClasse'],
      (variables?: JoinClasseMutationVariables) => gqlRequest<JoinClasseMutation, JoinClasseMutationVariables>(JoinClasseDocument, variables)(),
      options
    );
export const QuitClasseDocument = `
    mutation QuitClasse($id: ID!) {
  quitClasse(id: $id)
}
    `;
export const useQuitClasseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<QuitClasseMutation, TError, QuitClasseMutationVariables, TContext>) =>
    useMutation<QuitClasseMutation, TError, QuitClasseMutationVariables, TContext>(
      ['QuitClasse'],
      (variables?: QuitClasseMutationVariables) => gqlRequest<QuitClasseMutation, QuitClasseMutationVariables>(QuitClasseDocument, variables)(),
      options
    );
export const RemoveEleveFromClasseDocument = `
    mutation RemoveEleveFromClasse($classeId: ID!, $eleveId: ID!) {
  removeEleveFromClasse(classeId: $classeId, eleveId: $eleveId)
}
    `;
export const useRemoveEleveFromClasseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveEleveFromClasseMutation, TError, RemoveEleveFromClasseMutationVariables, TContext>) =>
    useMutation<RemoveEleveFromClasseMutation, TError, RemoveEleveFromClasseMutationVariables, TContext>(
      ['RemoveEleveFromClasse'],
      (variables?: RemoveEleveFromClasseMutationVariables) => gqlRequest<RemoveEleveFromClasseMutation, RemoveEleveFromClasseMutationVariables>(RemoveEleveFromClasseDocument, variables)(),
      options
    );
export const UpdateClasseDocument = `
    mutation UpdateClasse($classeId: String!, $input: ClasseInput!) {
  updateClasse(classeId: $classeId, input: $input)
}
    `;
export const useUpdateClasseMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateClasseMutation, TError, UpdateClasseMutationVariables, TContext>) =>
    useMutation<UpdateClasseMutation, TError, UpdateClasseMutationVariables, TContext>(
      ['UpdateClasse'],
      (variables?: UpdateClasseMutationVariables) => gqlRequest<UpdateClasseMutation, UpdateClasseMutationVariables>(UpdateClasseDocument, variables)(),
      options
    );
export const UpdateModuleDocument = `
    mutation UpdateModule($classeId: String!, $moduleConfig: ModuleConfigInput!) {
  updateModule(classeId: $classeId, moduleConfig: $moduleConfig) {
    _id
  }
}
    `;
export const useUpdateModuleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateModuleMutation, TError, UpdateModuleMutationVariables, TContext>) =>
    useMutation<UpdateModuleMutation, TError, UpdateModuleMutationVariables, TContext>(
      ['UpdateModule'],
      (variables?: UpdateModuleMutationVariables) => gqlRequest<UpdateModuleMutation, UpdateModuleMutationVariables>(UpdateModuleDocument, variables)(),
      options
    );
export const GitInfoDocument = `
    query GitInfo {
  gitInfo {
    sha
    message
  }
}
    `;
export const useGitInfoQuery = <
      TData = GitInfoQuery,
      TError = unknown
    >(
      variables?: GitInfoQueryVariables,
      options?: UseQueryOptions<GitInfoQuery, TError, TData>
    ) =>
    useQuery<GitInfoQuery, TError, TData>(
      variables === undefined ? ['GitInfo'] : ['GitInfo', variables],
      gqlRequest<GitInfoQuery, GitInfoQueryVariables>(GitInfoDocument, variables),
      options
    );
export const useInfiniteGitInfoQuery = <
      TData = GitInfoQuery,
      TError = unknown
    >(
      variables?: GitInfoQueryVariables,
      options?: UseInfiniteQueryOptions<GitInfoQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GitInfoQuery, TError, TData>(
      variables === undefined ? ['GitInfo.infinite'] : ['GitInfo.infinite', variables],
      (metaData) => gqlRequest<GitInfoQuery, GitInfoQueryVariables>(GitInfoDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const EtablissementsDocument = `
    query Etablissements($departement: String!) {
  etablissements(departement: $departement) {
    _id
    name
    idEtablissementOnisep
    commune
  }
}
    `;
export const useEtablissementsQuery = <
      TData = EtablissementsQuery,
      TError = unknown
    >(
      variables: EtablissementsQueryVariables,
      options?: UseQueryOptions<EtablissementsQuery, TError, TData>
    ) =>
    useQuery<EtablissementsQuery, TError, TData>(
      ['Etablissements', variables],
      gqlRequest<EtablissementsQuery, EtablissementsQueryVariables>(EtablissementsDocument, variables),
      options
    );
export const useInfiniteEtablissementsQuery = <
      TData = EtablissementsQuery,
      TError = unknown
    >(
      variables: EtablissementsQueryVariables,
      options?: UseInfiniteQueryOptions<EtablissementsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<EtablissementsQuery, TError, TData>(
      ['Etablissements.infinite', variables],
      (metaData) => gqlRequest<EtablissementsQuery, EtablissementsQueryVariables>(EtablissementsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const FaqItemsDocument = `
    query FaqItems {
  faqItems {
    _id
    question
    answer
  }
}
    `;
export const useFaqItemsQuery = <
      TData = FaqItemsQuery,
      TError = unknown
    >(
      variables?: FaqItemsQueryVariables,
      options?: UseQueryOptions<FaqItemsQuery, TError, TData>
    ) =>
    useQuery<FaqItemsQuery, TError, TData>(
      variables === undefined ? ['FaqItems'] : ['FaqItems', variables],
      gqlRequest<FaqItemsQuery, FaqItemsQueryVariables>(FaqItemsDocument, variables),
      options
    );
export const useInfiniteFaqItemsQuery = <
      TData = FaqItemsQuery,
      TError = unknown
    >(
      variables?: FaqItemsQueryVariables,
      options?: UseInfiniteQueryOptions<FaqItemsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<FaqItemsQuery, TError, TData>(
      variables === undefined ? ['FaqItems.infinite'] : ['FaqItems.infinite', variables],
      (metaData) => gqlRequest<FaqItemsQuery, FaqItemsQueryVariables>(FaqItemsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const FormationsDocument = `
    query Formations($onisepId: String!) {
  formations(onisepId: $onisepId) {
    _id
    name
  }
}
    `;
export const useFormationsQuery = <
      TData = FormationsQuery,
      TError = unknown
    >(
      variables: FormationsQueryVariables,
      options?: UseQueryOptions<FormationsQuery, TError, TData>
    ) =>
    useQuery<FormationsQuery, TError, TData>(
      ['Formations', variables],
      gqlRequest<FormationsQuery, FormationsQueryVariables>(FormationsDocument, variables),
      options
    );
export const useInfiniteFormationsQuery = <
      TData = FormationsQuery,
      TError = unknown
    >(
      variables: FormationsQueryVariables,
      options?: UseInfiniteQueryOptions<FormationsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<FormationsQuery, TError, TData>(
      ['Formations.infinite', variables],
      (metaData) => gqlRequest<FormationsQuery, FormationsQueryVariables>(FormationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const LyceesDocument = `
    query Lycees($departement: String, $hasIntervention: Boolean, $isLyceePro: Boolean) {
  lycees(
    departement: $departement
    hasIntervention: $hasIntervention
    isLyceePro: $isLyceePro
  ) {
    _id
    nom
    ville
    departement
    departementCode
    location {
      type
      coordinates
    }
    uai_ips
  }
}
    `;
export const useLyceesQuery = <
      TData = LyceesQuery,
      TError = unknown
    >(
      variables?: LyceesQueryVariables,
      options?: UseQueryOptions<LyceesQuery, TError, TData>
    ) =>
    useQuery<LyceesQuery, TError, TData>(
      variables === undefined ? ['Lycees'] : ['Lycees', variables],
      gqlRequest<LyceesQuery, LyceesQueryVariables>(LyceesDocument, variables),
      options
    );
export const useInfiniteLyceesQuery = <
      TData = LyceesQuery,
      TError = unknown
    >(
      variables?: LyceesQueryVariables,
      options?: UseInfiniteQueryOptions<LyceesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<LyceesQuery, TError, TData>(
      variables === undefined ? ['Lycees.infinite'] : ['Lycees.infinite', variables],
      (metaData) => gqlRequest<LyceesQuery, LyceesQueryVariables>(LyceesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PistesDocument = `
    query Pistes($filiere: String, $domaines: [String], $isApprentissage: Boolean, $isInsertionPro: Boolean, $typesFormation: [String], $classeHasModules: Boolean) {
  pistes(
    filiere: $filiere
    domaines: $domaines
    isApprentissage: $isApprentissage
    isInsertionPro: $isInsertionPro
    typesFormation: $typesFormation
    classeHasModules: $classeHasModules
  ) {
    _id
    name
    slug
    coverPicture
    bacs
    isInsertionPro
    typeFormation
  }
}
    `;
export const usePistesQuery = <
      TData = PistesQuery,
      TError = unknown
    >(
      variables?: PistesQueryVariables,
      options?: UseQueryOptions<PistesQuery, TError, TData>
    ) =>
    useQuery<PistesQuery, TError, TData>(
      variables === undefined ? ['Pistes'] : ['Pistes', variables],
      gqlRequest<PistesQuery, PistesQueryVariables>(PistesDocument, variables),
      options
    );
export const useInfinitePistesQuery = <
      TData = PistesQuery,
      TError = unknown
    >(
      variables?: PistesQueryVariables,
      options?: UseInfiniteQueryOptions<PistesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PistesQuery, TError, TData>(
      variables === undefined ? ['Pistes.infinite'] : ['Pistes.infinite', variables],
      (metaData) => gqlRequest<PistesQuery, PistesQueryVariables>(PistesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PisteBySlugDocument = `
    query PisteBySlug($slug: String!) {
  piste(slug: $slug) {
    _id
    name
    slug
    coverPicture
    bacs
    chapo
    content
    contentBacPro
    updatedAt
    typeEtablissement
    typeEnseignement
    typeFormat
    duree
    disponibleEnApprentissage
    pisteFeedback {
      hasFeedback
      knewThePiste
    }
    dureeStageFrom
    dureeStageTo
  }
}
    `;
export const usePisteBySlugQuery = <
      TData = PisteBySlugQuery,
      TError = unknown
    >(
      variables: PisteBySlugQueryVariables,
      options?: UseQueryOptions<PisteBySlugQuery, TError, TData>
    ) =>
    useQuery<PisteBySlugQuery, TError, TData>(
      ['PisteBySlug', variables],
      gqlRequest<PisteBySlugQuery, PisteBySlugQueryVariables>(PisteBySlugDocument, variables),
      options
    );
export const useInfinitePisteBySlugQuery = <
      TData = PisteBySlugQuery,
      TError = unknown
    >(
      variables: PisteBySlugQueryVariables,
      options?: UseInfiniteQueryOptions<PisteBySlugQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PisteBySlugQuery, TError, TData>(
      ['PisteBySlug.infinite', variables],
      (metaData) => gqlRequest<PisteBySlugQuery, PisteBySlugQueryVariables>(PisteBySlugDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const PisteByIdDocument = `
    query PisteById($_id: String!) {
  piste(_id: $_id) {
    _id
    name
    slug
  }
}
    `;
export const usePisteByIdQuery = <
      TData = PisteByIdQuery,
      TError = unknown
    >(
      variables: PisteByIdQueryVariables,
      options?: UseQueryOptions<PisteByIdQuery, TError, TData>
    ) =>
    useQuery<PisteByIdQuery, TError, TData>(
      ['PisteById', variables],
      gqlRequest<PisteByIdQuery, PisteByIdQueryVariables>(PisteByIdDocument, variables),
      options
    );
export const useInfinitePisteByIdQuery = <
      TData = PisteByIdQuery,
      TError = unknown
    >(
      variables: PisteByIdQueryVariables,
      options?: UseInfiniteQueryOptions<PisteByIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<PisteByIdQuery, TError, TData>(
      ['PisteById.infinite', variables],
      (metaData) => gqlRequest<PisteByIdQuery, PisteByIdQueryVariables>(PisteByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const SubmitPisteFeedbackDocument = `
    mutation SubmitPisteFeedback($input: PisteFeedbackInput!) {
  submitPisteFeedback(input: $input)
}
    `;
export const useSubmitPisteFeedbackMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitPisteFeedbackMutation, TError, SubmitPisteFeedbackMutationVariables, TContext>) =>
    useMutation<SubmitPisteFeedbackMutation, TError, SubmitPisteFeedbackMutationVariables, TContext>(
      ['SubmitPisteFeedback'],
      (variables?: SubmitPisteFeedbackMutationVariables) => gqlRequest<SubmitPisteFeedbackMutation, SubmitPisteFeedbackMutationVariables>(SubmitPisteFeedbackDocument, variables)(),
      options
    );
export const ResourcesDocument = `
    query Resources {
  resources {
    _id
    name
    url
    category
    type
    description
    order
  }
}
    `;
export const useResourcesQuery = <
      TData = ResourcesQuery,
      TError = unknown
    >(
      variables?: ResourcesQueryVariables,
      options?: UseQueryOptions<ResourcesQuery, TError, TData>
    ) =>
    useQuery<ResourcesQuery, TError, TData>(
      variables === undefined ? ['Resources'] : ['Resources', variables],
      gqlRequest<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, variables),
      options
    );
export const useInfiniteResourcesQuery = <
      TData = ResourcesQuery,
      TError = unknown
    >(
      variables?: ResourcesQueryVariables,
      options?: UseInfiniteQueryOptions<ResourcesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ResourcesQuery, TError, TData>(
      variables === undefined ? ['Resources.infinite'] : ['Resources.infinite', variables],
      (metaData) => gqlRequest<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const AddProfDocument = `
    mutation AddProf($classeId: ID!, $profId: ID!) {
  addProf(classeId: $classeId, profId: $profId)
}
    `;
export const useAddProfMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddProfMutation, TError, AddProfMutationVariables, TContext>) =>
    useMutation<AddProfMutation, TError, AddProfMutationVariables, TContext>(
      ['AddProf'],
      (variables?: AddProfMutationVariables) => gqlRequest<AddProfMutation, AddProfMutationVariables>(AddProfDocument, variables)(),
      options
    );
export const CountLyceenAlgoDocument = `
    mutation CountLyceenAlgo($lyceenAlgoCounter: String!) {
  countLyceenAlgo(lyceenAlgoCounter: $lyceenAlgoCounter)
}
    `;
export const useCountLyceenAlgoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CountLyceenAlgoMutation, TError, CountLyceenAlgoMutationVariables, TContext>) =>
    useMutation<CountLyceenAlgoMutation, TError, CountLyceenAlgoMutationVariables, TContext>(
      ['CountLyceenAlgo'],
      (variables?: CountLyceenAlgoMutationVariables) => gqlRequest<CountLyceenAlgoMutation, CountLyceenAlgoMutationVariables>(CountLyceenAlgoDocument, variables)(),
      options
    );
export const CreateCvdesignrUserDocument = `
    mutation CreateCvdesignrUser($cvdesignrPassword: String!) {
  createCvdesignrUser(cvdesignrPassword: $cvdesignrPassword)
}
    `;
export const useCreateCvdesignrUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CreateCvdesignrUserMutation, TError, CreateCvdesignrUserMutationVariables, TContext>) =>
    useMutation<CreateCvdesignrUserMutation, TError, CreateCvdesignrUserMutationVariables, TContext>(
      ['CreateCvdesignrUser'],
      (variables?: CreateCvdesignrUserMutationVariables) => gqlRequest<CreateCvdesignrUserMutation, CreateCvdesignrUserMutationVariables>(CreateCvdesignrUserDocument, variables)(),
      options
    );
export const CvdesignrFlowDocument = `
    query CvdesignrFlow {
  cvdesignrFlow {
    kind
    value
  }
}
    `;
export const useCvdesignrFlowQuery = <
      TData = CvdesignrFlowQuery,
      TError = unknown
    >(
      variables?: CvdesignrFlowQueryVariables,
      options?: UseQueryOptions<CvdesignrFlowQuery, TError, TData>
    ) =>
    useQuery<CvdesignrFlowQuery, TError, TData>(
      variables === undefined ? ['CvdesignrFlow'] : ['CvdesignrFlow', variables],
      gqlRequest<CvdesignrFlowQuery, CvdesignrFlowQueryVariables>(CvdesignrFlowDocument, variables),
      options
    );
export const useInfiniteCvdesignrFlowQuery = <
      TData = CvdesignrFlowQuery,
      TError = unknown
    >(
      variables?: CvdesignrFlowQueryVariables,
      options?: UseInfiniteQueryOptions<CvdesignrFlowQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CvdesignrFlowQuery, TError, TData>(
      variables === undefined ? ['CvdesignrFlow.infinite'] : ['CvdesignrFlow.infinite', variables],
      (metaData) => gqlRequest<CvdesignrFlowQuery, CvdesignrFlowQueryVariables>(CvdesignrFlowDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const DeleteHorsScopeUserDocument = `
    mutation DeleteHorsScopeUser {
  deleteHorsScopeUser
}
    `;
export const useDeleteHorsScopeUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteHorsScopeUserMutation, TError, DeleteHorsScopeUserMutationVariables, TContext>) =>
    useMutation<DeleteHorsScopeUserMutation, TError, DeleteHorsScopeUserMutationVariables, TContext>(
      ['DeleteHorsScopeUser'],
      (variables?: DeleteHorsScopeUserMutationVariables) => gqlRequest<DeleteHorsScopeUserMutation, DeleteHorsScopeUserMutationVariables>(DeleteHorsScopeUserDocument, variables)(),
      options
    );
export const DevenirEclaireurDocument = `
    mutation DevenirEclaireur {
  devenirEclaireur
}
    `;
export const useDevenirEclaireurMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DevenirEclaireurMutation, TError, DevenirEclaireurMutationVariables, TContext>) =>
    useMutation<DevenirEclaireurMutation, TError, DevenirEclaireurMutationVariables, TContext>(
      ['DevenirEclaireur'],
      (variables?: DevenirEclaireurMutationVariables) => gqlRequest<DevenirEclaireurMutation, DevenirEclaireurMutationVariables>(DevenirEclaireurDocument, variables)(),
      options
    );
export const EclaireurDocument = `
    query Eclaireur($id: ID!) {
  eclaireur(id: $id) {
    _id
    profile {
      status
      firstName
      lastName
      role
      filiere
      filiereBacPro
      picture
      age
      studiesFirstYear
      studies {
        year
        formation
        etablissement
        formationYear
        ville
        codePostal
        skippingYear
        skippingYearOccupation
        option
        optionAutre
        optionMentionCMI
        skippingYearOther
        secondFormation {
          departement
          etablissement
          etablissementId
          formation
          formationId
          formationYear
          doubleDegree
          ville
          codePostal
        }
      }
      sourceOfFinanceStudies
      livedWithFamilyBacP1
      knewNobodyBacP1
      willReviewCV
      apprentissage
      logementEtudiant
      studiedAbroad
      tagline
      eclaireurQuestions {
        key
        value
      }
      speBac
      lycee
      lyceeCity
      departement
    }
    pistes {
      _id
      name
      coverPicture
      slug
    }
    contactRequestId
    wasLyceenInspire
  }
}
    `;
export const useEclaireurQuery = <
      TData = EclaireurQuery,
      TError = unknown
    >(
      variables: EclaireurQueryVariables,
      options?: UseQueryOptions<EclaireurQuery, TError, TData>
    ) =>
    useQuery<EclaireurQuery, TError, TData>(
      ['Eclaireur', variables],
      gqlRequest<EclaireurQuery, EclaireurQueryVariables>(EclaireurDocument, variables),
      options
    );
export const useInfiniteEclaireurQuery = <
      TData = EclaireurQuery,
      TError = unknown
    >(
      variables: EclaireurQueryVariables,
      options?: UseInfiniteQueryOptions<EclaireurQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<EclaireurQuery, TError, TData>(
      ['Eclaireur.infinite', variables],
      (metaData) => gqlRequest<EclaireurQuery, EclaireurQueryVariables>(EclaireurDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const EclaireursDocument = `
    query Eclaireurs($filters: EclaireurQueryInput, $limit: Int, $skip: Int, $group: String) {
  eclaireurs(filters: $filters, limit: $limit, skip: $skip, group: $group) {
    _id
    isProfileComplete
    profile {
      status
      firstName
      lastName
      role
      filiere
      filiereBacPro
      picture
      age
      studiesFirstYear
      livedWithFamilyBacP1
      logementEtudiant
      sourceOfFinanceStudies
      knewNobodyBacP1
      apprentissage
      studiedAbroad
      lycee
      departement
      lyceeCity
      studies {
        year
        formation
        etablissement
        formationYear
        ville
        codePostal
        secondFormation {
          departement
          etablissement
          etablissementId
          formation
          formationId
          formationYear
          doubleDegree
          ville
          codePostal
        }
      }
    }
    pistes {
      _id
      name
    }
  }
}
    `;
export const useEclaireursQuery = <
      TData = EclaireursQuery,
      TError = unknown
    >(
      variables?: EclaireursQueryVariables,
      options?: UseQueryOptions<EclaireursQuery, TError, TData>
    ) =>
    useQuery<EclaireursQuery, TError, TData>(
      variables === undefined ? ['Eclaireurs'] : ['Eclaireurs', variables],
      gqlRequest<EclaireursQuery, EclaireursQueryVariables>(EclaireursDocument, variables),
      options
    );
export const useInfiniteEclaireursQuery = <
      TData = EclaireursQuery,
      TError = unknown
    >(
      variables?: EclaireursQueryVariables,
      options?: UseInfiniteQueryOptions<EclaireursQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<EclaireursQuery, TError, TData>(
      variables === undefined ? ['Eclaireurs.infinite'] : ['Eclaireurs.infinite', variables],
      (metaData) => gqlRequest<EclaireursQuery, EclaireursQueryVariables>(EclaireursDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const EleveDocument = `
    query Eleve($id: ID!) {
  eleve(id: $id) {
    activitesBacPro {
      activiteId
      status
    }
    profile {
      firstName
      lastName
      diplomes
      difficulteTrouverStage
      ressentiFormation
      softSkillsExperience
      softSkillsList
      softSkillsDifficultes
      softSkillsActions
      softSkillsRessenti
      softSkillsAmeliorations
      competencesActivite
      competencesList
      etapesProjet
      planActionObjectif
      planActionTemps
      planActionEntreprendre
      planActionComplementaire
      mesQualites
      qualitesAmeliorer
      howToImproveQualite
      stageDuree
      stageSecteurActivite
      stageMetier
      stageGeographie
      stageMissions
      stageTypeEntreprise
      stageMotsCles
      stageSite
      preferenceFormatClasse
      preferenceEncadrement
      preferenceRevisions
      preferenceEmploiDuTemps
      formationMotiveContexte
      formationMotiveDemarches
      formationMotiveApports
      formationMotiveCadre
      formationMotiveAtouts
      formationMotiveQualites
      typeLogement
      demenagement
      gererBudget
      rencontrerDuMonde
      formationRoute
      centresDinterets {
        centresDinterets
        sport
        danse
        autre
      }
      preferencesApprentissage
      prioritesAvenir
      matieresPreferes
      meConnaitreQualites
      metierOuSecteurReve {
        saitMetierOuSecteur
        metierOuSecteur
        pourraitInteresser
      }
      choixFormation {
        choisiFormation
        pourquoiChoisi
        interessant
      }
      adequationPreferencesApprentissage {
        correspond
        pourquoiNon
      }
      adequationMetierOuSecteurReve
      adequationCentresInteretsPriorites
      adequationQualites
      pointsFortsScolaires {
        meilleuresMatieres
        correspondentAuxMatieresPreferees
      }
      agroSectorActivity1 {
        mots
      }
      agroSectorActivity3 {
        continueStudiesOrProLife
        whatDoIlikeMostAfterBac
        whatDoIlikeMostContinueStudies
      }
      experienceStage
      stageCapacitesSociales
      stageCapacitesPersonnelles
      stageCapacitesMethodologiques
      softSkillsPlanAction
      softSkillEvaluations {
        key
        value
      }
      derniereExperienceStage
      capacitesSocialesStage
      capacitesPersonnellesStage
      capacitesMethodologiquesStage
      capacitesSocialesADevelopper
      capacitesPersonnellesADevelopper
      capacitesMethodologiquesADevelopper
      motivationsEtudes
      motivationsTravail
      actionsEtudes
      imagineDans5ans
      imageValeur
      motsclesValeur
      mesQuestionnements
      aspirationsMetiersQuiInteressaient
      aspirationsMetiersQuiInteressent
      aspirationsCentresInterets
      aspirationsCeEnQuoiJeSuisFort
      aspirationsOntEvolue
      aspirationsPointsCommunsMetiersValeurs
      aspirationsForcesUtiles
      aspirationsPointsCommunsMetiersCentresInterets
      secteursInterets
      secteursCompetencesTransversales
      secteursCompetencesADevelopper
      formationComparaisons {
        pisteId
        duree
        cout
        experiencePro
        debouches
        correspond
        correspondpas
        order
      }
      formationChoixPiste
      formationEtablissements
      formationSelective
      formationPointsForts
      formationMoyenne
      formationMatiereBonsResultats
      formationSavoirsEtre
      formationEvaluationMotivation
      formationCompetencesTransversales
      formationMesPointsForts
      formationMesPointsAmelioration
      formationMesExperiencesUtiles
      vieEtudianteDemenager
      vieEtudianteTypeLogement
      vieEtudianteAideDemenagement
      vieEtudianteFinancement
      vieEtudianteQuestionsAuxEclaireurs
      bilansModules {
        moduleId
        questions {
          id
          answer
        }
      }
      matieres {
        matiere
        grade
        like
      }
      spes_premiere
      spes_terminale
      spe_abandonnee_premiere
      moyennePremiere
      motivation
      environnement {
        type
        interest
      }
      encadrement
      boostAlternanceApprentissage
      boostConnaisPersonne
      boostPartir
      boostBudget
    }
    algoResults {
      pisteId
      score
      name
    }
  }
}
    `;
export const useEleveQuery = <
      TData = EleveQuery,
      TError = unknown
    >(
      variables: EleveQueryVariables,
      options?: UseQueryOptions<EleveQuery, TError, TData>
    ) =>
    useQuery<EleveQuery, TError, TData>(
      ['Eleve', variables],
      gqlRequest<EleveQuery, EleveQueryVariables>(EleveDocument, variables),
      options
    );
export const useInfiniteEleveQuery = <
      TData = EleveQuery,
      TError = unknown
    >(
      variables: EleveQueryVariables,
      options?: UseInfiniteQueryOptions<EleveQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<EleveQuery, TError, TData>(
      ['Eleve.infinite', variables],
      (metaData) => gqlRequest<EleveQuery, EleveQueryVariables>(EleveDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ElevesActivitesBacProDocument = `
    query ElevesActivitesBacPro {
  currentClasse {
    _id
    eleves {
      _id
      profile {
        firstName
        lastName
      }
      activitesBacPro {
        activiteId
        status
      }
    }
  }
}
    `;
export const useElevesActivitesBacProQuery = <
      TData = ElevesActivitesBacProQuery,
      TError = unknown
    >(
      variables?: ElevesActivitesBacProQueryVariables,
      options?: UseQueryOptions<ElevesActivitesBacProQuery, TError, TData>
    ) =>
    useQuery<ElevesActivitesBacProQuery, TError, TData>(
      variables === undefined ? ['ElevesActivitesBacPro'] : ['ElevesActivitesBacPro', variables],
      gqlRequest<ElevesActivitesBacProQuery, ElevesActivitesBacProQueryVariables>(ElevesActivitesBacProDocument, variables),
      options
    );
export const useInfiniteElevesActivitesBacProQuery = <
      TData = ElevesActivitesBacProQuery,
      TError = unknown
    >(
      variables?: ElevesActivitesBacProQueryVariables,
      options?: UseInfiniteQueryOptions<ElevesActivitesBacProQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ElevesActivitesBacProQuery, TError, TData>(
      variables === undefined ? ['ElevesActivitesBacPro.infinite'] : ['ElevesActivitesBacPro.infinite', variables],
      (metaData) => gqlRequest<ElevesActivitesBacProQuery, ElevesActivitesBacProQueryVariables>(ElevesActivitesBacProDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const JobreadyTokenDocument = `
    mutation JobreadyToken {
  jobreadyToken
}
    `;
export const useJobreadyTokenMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<JobreadyTokenMutation, TError, JobreadyTokenMutationVariables, TContext>) =>
    useMutation<JobreadyTokenMutation, TError, JobreadyTokenMutationVariables, TContext>(
      ['JobreadyToken'],
      (variables?: JobreadyTokenMutationVariables) => gqlRequest<JobreadyTokenMutation, JobreadyTokenMutationVariables>(JobreadyTokenDocument, variables)(),
      options
    );
export const LyceenDocument = `
    query Lyceen($id: ID!) {
  eleve(id: $id) {
    profile {
      firstName
      lastName
      age
      filiere
      filiereTechno
      filiereBacPro
      niveau
      matieres {
        matiere
        grade
        like
      }
      spes_premiere
      spes_terminale
      spe_abandonnee_premiere
      lycee
      lyceeCity
      departement
    }
    algoResults {
      pisteId
      score
      name
    }
  }
}
    `;
export const useLyceenQuery = <
      TData = LyceenQuery,
      TError = unknown
    >(
      variables: LyceenQueryVariables,
      options?: UseQueryOptions<LyceenQuery, TError, TData>
    ) =>
    useQuery<LyceenQuery, TError, TData>(
      ['Lyceen', variables],
      gqlRequest<LyceenQuery, LyceenQueryVariables>(LyceenDocument, variables),
      options
    );
export const useInfiniteLyceenQuery = <
      TData = LyceenQuery,
      TError = unknown
    >(
      variables: LyceenQueryVariables,
      options?: UseInfiniteQueryOptions<LyceenQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<LyceenQuery, TError, TData>(
      ['Lyceen.infinite', variables],
      (metaData) => gqlRequest<LyceenQuery, LyceenQueryVariables>(LyceenDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const MyBacProActivitesDocument = `
    query MyBacProActivites {
  myUser {
    activitesBacPro {
      activiteId
      status
    }
  }
}
    `;
export const useMyBacProActivitesQuery = <
      TData = MyBacProActivitesQuery,
      TError = unknown
    >(
      variables?: MyBacProActivitesQueryVariables,
      options?: UseQueryOptions<MyBacProActivitesQuery, TError, TData>
    ) =>
    useQuery<MyBacProActivitesQuery, TError, TData>(
      variables === undefined ? ['MyBacProActivites'] : ['MyBacProActivites', variables],
      gqlRequest<MyBacProActivitesQuery, MyBacProActivitesQueryVariables>(MyBacProActivitesDocument, variables),
      options
    );
export const useInfiniteMyBacProActivitesQuery = <
      TData = MyBacProActivitesQuery,
      TError = unknown
    >(
      variables?: MyBacProActivitesQueryVariables,
      options?: UseInfiniteQueryOptions<MyBacProActivitesQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<MyBacProActivitesQuery, TError, TData>(
      variables === undefined ? ['MyBacProActivites.infinite'] : ['MyBacProActivites.infinite', variables],
      (metaData) => gqlRequest<MyBacProActivitesQuery, MyBacProActivitesQueryVariables>(MyBacProActivitesDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const MyProfileDocument = `
    query MyProfile {
  myUser {
    _id
    profile {
      title
      fonction
      fonctionAutre
      firstName
      lastName
      departement
      birthDate
      lyceeId
      lyceeCity
      lycee
      gender
      referredBy
      algoResultsRating
      region
      codePostal
      diplomes
      difficulteTrouverStage
      ressentiFormation
      motivation
      hadInspirePresentation
      matieres {
        matiere
        like
        grade
      }
      previsionOccupationPostBac
      previsionAnneesEtudesPostBac
      previsionQuitterDomicileParental
      previsionEloignementDomicileParental
      previsionTempsMaxTrajetParJour
      previsionTypeTransport
      connaitCoutEtudes
      financementEtudesFrein
      isBoursierSecondaire
      debouches {
        key
        value
      }
      connaitPersonnesMemeDomaine
      prevoitCreerEntreprise
      avenirPro {
        key
        value
      }
      attitudes {
        key
        value
      }
      mesQualites
      qualitesAmeliorer
      howToImproveQualite
      favoritePistes {
        id
      }
      favoriteEclaireurs {
        _id
      }
      etapesProjet
      softSkillsExperience
      softSkillsList
      softSkillsDifficultes
      softSkillsActions
      softSkillsRessenti
      softSkillsAmeliorations
      competencesActivite
      competencesList
      pedagogie_filiere_generale
      pedagogie_filiere_professionnelle
      pedagogie_filiere_technologique
      planActionObjectif
      planActionTemps
      planActionEntreprendre
      planActionComplementaire
      stageDuree
      stageSecteurActivite
      stageMetier
      stageGeographie
      stageMissions
      stageTypeEntreprise
      stageMotsCles
      stageSite
      checklistCV
      checklistLM
      analyseOffreEmploi
      stageEntrepriseActivite
      stageEntrepriseSoftSkills
      creationEntrepriseOpinion
      demenagement
      typeLogement
      gererBudget
      rencontrerDuMonde
      formationRoute
      preferenceFormatClasse
      preferenceEncadrement
      preferenceRevisions
      preferenceEmploiDuTemps
      formationMotiveContexte
      formationMotiveDemarches
      formationMotiveApports
      formationMotiveCadre
      formationMotiveAtouts
      formationMotiveQualites
      centresDinterets {
        centresDinterets
        sport
        danse
        autre
      }
      preferencesApprentissage
      prioritesAvenir
      matieresPreferes
      meConnaitreQualites
      metierOuSecteurReve {
        saitMetierOuSecteur
        metierOuSecteur
        pourraitInteresser
      }
      choixFormation {
        choisiFormation
        pourquoiChoisi
        interessant
      }
      adequationPreferencesApprentissage {
        correspond
        pourquoiNon
      }
      adequationMetierOuSecteurReve
      adequationCentresInteretsPriorites
      adequationQualites
      pointsFortsScolaires {
        meilleuresMatieres
        correspondentAuxMatieresPreferees
      }
      experienceStage
      stageCapacitesSociales
      stageCapacitesPersonnelles
      stageCapacitesMethodologiques
      softSkillsPlanAction
      agroSectorActivity1 {
        mots
      }
      agroSectorActivity3 {
        continueStudiesOrProLife
        whatDoIlikeMostAfterBac
        whatDoIlikeMostContinueStudies
      }
      lettreDeMotiv {
        key
        value
      }
      etapesEntreprise {
        key
        value
      }
      pistesOpinions {
        pisteName
        pisteId
        like
        dislike
      }
      entretienFeedback {
        key
        value
      }
      softSkillEvaluations {
        key
        value
      }
      derniereExperienceStage
      capacitesSocialesStage
      capacitesPersonnellesStage
      capacitesMethodologiquesStage
      capacitesSocialesADevelopper
      capacitesPersonnellesADevelopper
      capacitesMethodologiquesADevelopper
      motivationsEtudes
      motivationsTravail
      actionsEtudes
      imagineDans5ans
      imageValeur
      motsclesValeur
      mesQuestionnements
      aspirationsMetiersQuiInteressaient
      aspirationsMetiersQuiInteressent
      aspirationsCentresInterets
      aspirationsCeEnQuoiJeSuisFort
      aspirationsOntEvolue
      aspirationsPointsCommunsMetiersValeurs
      aspirationsForcesUtiles
      aspirationsPointsCommunsMetiersCentresInterets
      secteursInterets
      secteursCompetencesTransversales
      secteursCompetencesADevelopper
      formationComparaisons {
        pisteId
        duree
        cout
        experiencePro
        debouches
        correspond
        correspondpas
        order
      }
      formationChoixPiste
      formationEtablissements
      formationSelective
      formationPointsForts
      formationMoyenne
      formationMatiereBonsResultats
      formationSavoirsEtre
      formationEvaluationMotivation
      formationCompetencesTransversales
      formationMesPointsForts
      formationMesPointsAmelioration
      formationMesExperiencesUtiles
      vieEtudianteDemenager
      vieEtudianteTypeLogement
      vieEtudianteAideDemenagement
      vieEtudianteFinancement
      vieEtudianteQuestionsAuxEclaireurs
      bilansModules {
        moduleId
        questions {
          id
          answer
        }
      }
      age
      tagline
      studiesFirstYear
      speBac
      studies {
        year
        formation
        formationId
        etablissement
        etablissementId
        formationYear
        departement
        ville
        pays
        codePostal
        skippingYear
        skippingYearOccupation
        skippingYearOther
        option
        optionAutre
        optionMentionCMI
        secondFormation {
          departement
          etablissement
          etablissementId
          formation
          formationId
          formationYear
          doubleDegree
          ville
          pays
          codePostal
          option
        }
      }
      knewNobodyBacP1
      livedWithFamilyBacP1
      studiedAbroad
      apprentissage
      logementEtudiant
      sourceOfFinanceStudies
      eclaireurQuestions {
        key
        value
      }
      willReviewCV
      niveau
      isNiveauConfirmed
      filiere
      filiereTechno
      filiereBacPro
      lyceeStudies {
        annee
        filiere
        niveau
        filiereBacPro
      }
      picture
      boursierLycee
      spes_premiere
      spes_terminale
      spe_abandonnee_premiere
      hasOptions
      options_terminale
      domains {
        domain
        interest
      }
      motivation
      moyennePremiere
      environnement {
        type
        interest
      }
      encadrement
      boostAlternanceApprentissage
      boostPartir
      boostConnaisPersonne
      boostBudget
      isBoursierSecondaire
      inscriptionPedagogique
      isLyceenPrioritaire
      prochainesEtapes {
        name
        status
      }
      newsletter
      update_newsletter
      notifications {
        media {
          sms
          email
          onsite
        }
      }
      partnership
      obendyWidgetUrl
      obendyPixelAnalyticsUrl
    }
    emails {
      address
      verified
    }
    pistes {
      _id
      name
      slug
      coverPicture
      typeFormation
    }
    isProfileComplete
    algoResults {
      pisteId
      name
      score
      rating
    }
    isQuestionnaireComplete
    phoneNumber {
      number
      verified
    }
    ssoId
    createdAt
  }
}
    `;
export const useMyProfileQuery = <
      TData = MyProfileQuery,
      TError = unknown
    >(
      variables?: MyProfileQueryVariables,
      options?: UseQueryOptions<MyProfileQuery, TError, TData>
    ) =>
    useQuery<MyProfileQuery, TError, TData>(
      variables === undefined ? ['MyProfile'] : ['MyProfile', variables],
      gqlRequest<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, variables),
      options
    );
export const useInfiniteMyProfileQuery = <
      TData = MyProfileQuery,
      TError = unknown
    >(
      variables?: MyProfileQueryVariables,
      options?: UseInfiniteQueryOptions<MyProfileQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<MyProfileQuery, TError, TData>(
      variables === undefined ? ['MyProfile.infinite'] : ['MyProfile.infinite', variables],
      (metaData) => gqlRequest<MyProfileQuery, MyProfileQueryVariables>(MyProfileDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const ProfByEmailDocument = `
    query ProfByEmail($email: String!) {
  profByEmail(email: $email) {
    _id
    profile {
      firstName
      lastName
    }
  }
}
    `;
export const useProfByEmailQuery = <
      TData = ProfByEmailQuery,
      TError = unknown
    >(
      variables: ProfByEmailQueryVariables,
      options?: UseQueryOptions<ProfByEmailQuery, TError, TData>
    ) =>
    useQuery<ProfByEmailQuery, TError, TData>(
      ['ProfByEmail', variables],
      gqlRequest<ProfByEmailQuery, ProfByEmailQueryVariables>(ProfByEmailDocument, variables),
      options
    );
export const useInfiniteProfByEmailQuery = <
      TData = ProfByEmailQuery,
      TError = unknown
    >(
      variables: ProfByEmailQueryVariables,
      options?: UseInfiniteQueryOptions<ProfByEmailQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ProfByEmailQuery, TError, TData>(
      ['ProfByEmail.infinite', variables],
      (metaData) => gqlRequest<ProfByEmailQuery, ProfByEmailQueryVariables>(ProfByEmailDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const RateAlgoResultDocument = `
    mutation RateAlgoResult($pisteId: ID!, $rating: Int!) {
  rateAlgoResult(pisteId: $pisteId, rating: $rating)
}
    `;
export const useRateAlgoResultMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RateAlgoResultMutation, TError, RateAlgoResultMutationVariables, TContext>) =>
    useMutation<RateAlgoResultMutation, TError, RateAlgoResultMutationVariables, TContext>(
      ['RateAlgoResult'],
      (variables?: RateAlgoResultMutationVariables) => gqlRequest<RateAlgoResultMutation, RateAlgoResultMutationVariables>(RateAlgoResultDocument, variables)(),
      options
    );
export const RemoveProfDocument = `
    mutation RemoveProf($classeId: ID!, $profId: ID!) {
  removeProf(classeId: $classeId, profId: $profId)
}
    `;
export const useRemoveProfMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveProfMutation, TError, RemoveProfMutationVariables, TContext>) =>
    useMutation<RemoveProfMutation, TError, RemoveProfMutationVariables, TContext>(
      ['RemoveProf'],
      (variables?: RemoveProfMutationVariables) => gqlRequest<RemoveProfMutation, RemoveProfMutationVariables>(RemoveProfDocument, variables)(),
      options
    );
export const ResetDemoDocument = `
    mutation ResetDemo {
  resetDemo
}
    `;
export const useResetDemoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResetDemoMutation, TError, ResetDemoMutationVariables, TContext>) =>
    useMutation<ResetDemoMutation, TError, ResetDemoMutationVariables, TContext>(
      ['ResetDemo'],
      (variables?: ResetDemoMutationVariables) => gqlRequest<ResetDemoMutation, ResetDemoMutationVariables>(ResetDemoDocument, variables)(),
      options
    );
export const SetActiviteBacProDocument = `
    mutation SetActiviteBacPro($activiteId: ID!, $status: String!, $moduleActivites: [String]) {
  setActiviteBacPro(
    activiteId: $activiteId
    status: $status
    moduleActivites: $moduleActivites
  )
}
    `;
export const useSetActiviteBacProMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetActiviteBacProMutation, TError, SetActiviteBacProMutationVariables, TContext>) =>
    useMutation<SetActiviteBacProMutation, TError, SetActiviteBacProMutationVariables, TContext>(
      ['SetActiviteBacPro'],
      (variables?: SetActiviteBacProMutationVariables) => gqlRequest<SetActiviteBacProMutation, SetActiviteBacProMutationVariables>(SetActiviteBacProDocument, variables)(),
      options
    );
export const SetBilanModuleDocument = `
    mutation SetBilanModule($moduleId: ID!, $questions: [BilanModuleQuestionInput]!) {
  setBilanModule(moduleId: $moduleId, questions: $questions)
}
    `;
export const useSetBilanModuleMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetBilanModuleMutation, TError, SetBilanModuleMutationVariables, TContext>) =>
    useMutation<SetBilanModuleMutation, TError, SetBilanModuleMutationVariables, TContext>(
      ['SetBilanModule'],
      (variables?: SetBilanModuleMutationVariables) => gqlRequest<SetBilanModuleMutation, SetBilanModuleMutationVariables>(SetBilanModuleDocument, variables)(),
      options
    );
export const SetEclaireurMobiliteGroupDocument = `
    mutation SetEclaireurMobiliteGroup($hasBeenClicked: Boolean!) {
  setEclaireurMobiliteGroup(hasBeenClicked: $hasBeenClicked)
}
    `;
export const useSetEclaireurMobiliteGroupMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetEclaireurMobiliteGroupMutation, TError, SetEclaireurMobiliteGroupMutationVariables, TContext>) =>
    useMutation<SetEclaireurMobiliteGroupMutation, TError, SetEclaireurMobiliteGroupMutationVariables, TContext>(
      ['SetEclaireurMobiliteGroup'],
      (variables?: SetEclaireurMobiliteGroupMutationVariables) => gqlRequest<SetEclaireurMobiliteGroupMutation, SetEclaireurMobiliteGroupMutationVariables>(SetEclaireurMobiliteGroupDocument, variables)(),
      options
    );
export const SetLyceeStudyYearDocument = `
    mutation SetLyceeStudyYear($niveau: String!, $filiere: String, $filiereTechno: String, $filiereBacPro: String) {
  setLyceeStudyYear(
    niveau: $niveau
    filiere: $filiere
    filiereTechno: $filiereTechno
    filiereBacPro: $filiereBacPro
  )
}
    `;
export const useSetLyceeStudyYearMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetLyceeStudyYearMutation, TError, SetLyceeStudyYearMutationVariables, TContext>) =>
    useMutation<SetLyceeStudyYearMutation, TError, SetLyceeStudyYearMutationVariables, TContext>(
      ['SetLyceeStudyYear'],
      (variables?: SetLyceeStudyYearMutationVariables) => gqlRequest<SetLyceeStudyYearMutation, SetLyceeStudyYearMutationVariables>(SetLyceeStudyYearDocument, variables)(),
      options
    );
export const SetMyProfileDocument = `
    mutation SetMyProfile($input: UserProfileInput!) {
  setMyProfile(input: $input)
}
    `;
export const useSetMyProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetMyProfileMutation, TError, SetMyProfileMutationVariables, TContext>) =>
    useMutation<SetMyProfileMutation, TError, SetMyProfileMutationVariables, TContext>(
      ['SetMyProfile'],
      (variables?: SetMyProfileMutationVariables) => gqlRequest<SetMyProfileMutation, SetMyProfileMutationVariables>(SetMyProfileDocument, variables)(),
      options
    );
export const SetPhoneNumberDocument = `
    mutation SetPhoneNumber($numberToVerify: String!, $tokenToVerify: String) {
  setPhoneNumber(numberToVerify: $numberToVerify, tokenToVerify: $tokenToVerify)
}
    `;
export const useSetPhoneNumberMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetPhoneNumberMutation, TError, SetPhoneNumberMutationVariables, TContext>) =>
    useMutation<SetPhoneNumberMutation, TError, SetPhoneNumberMutationVariables, TContext>(
      ['SetPhoneNumber'],
      (variables?: SetPhoneNumberMutationVariables) => gqlRequest<SetPhoneNumberMutation, SetPhoneNumberMutationVariables>(SetPhoneNumberDocument, variables)(),
      options
    );
export const SetStateOfMindDocument = `
    mutation SetStateOfMind($input: StateOfMindInput!) {
  setStateOfMind(input: $input)
}
    `;
export const useSetStateOfMindMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetStateOfMindMutation, TError, SetStateOfMindMutationVariables, TContext>) =>
    useMutation<SetStateOfMindMutation, TError, SetStateOfMindMutationVariables, TContext>(
      ['SetStateOfMind'],
      (variables?: SetStateOfMindMutationVariables) => gqlRequest<SetStateOfMindMutation, SetStateOfMindMutationVariables>(SetStateOfMindDocument, variables)(),
      options
    );
export const SetStudyYearDocument = `
    mutation SetStudyYear($studyYear: StudyYearInput!) {
  setStudyYear(studyYear: $studyYear)
}
    `;
export const useSetStudyYearMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SetStudyYearMutation, TError, SetStudyYearMutationVariables, TContext>) =>
    useMutation<SetStudyYearMutation, TError, SetStudyYearMutationVariables, TContext>(
      ['SetStudyYear'],
      (variables?: SetStudyYearMutationVariables) => gqlRequest<SetStudyYearMutation, SetStudyYearMutationVariables>(SetStudyYearDocument, variables)(),
      options
    );
export const StateOfMindDocument = `
    query StateOfMind {
  myUser {
    stateOfMind {
      seLancerDansEtudesSup
      souhaiteAccompagnement
    }
  }
}
    `;
export const useStateOfMindQuery = <
      TData = StateOfMindQuery,
      TError = unknown
    >(
      variables?: StateOfMindQueryVariables,
      options?: UseQueryOptions<StateOfMindQuery, TError, TData>
    ) =>
    useQuery<StateOfMindQuery, TError, TData>(
      variables === undefined ? ['StateOfMind'] : ['StateOfMind', variables],
      gqlRequest<StateOfMindQuery, StateOfMindQueryVariables>(StateOfMindDocument, variables),
      options
    );
export const useInfiniteStateOfMindQuery = <
      TData = StateOfMindQuery,
      TError = unknown
    >(
      variables?: StateOfMindQueryVariables,
      options?: UseInfiniteQueryOptions<StateOfMindQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<StateOfMindQuery, TError, TData>(
      variables === undefined ? ['StateOfMind.infinite'] : ['StateOfMind.infinite', variables],
      (metaData) => gqlRequest<StateOfMindQuery, StateOfMindQueryVariables>(StateOfMindDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};

export const TriggerAlgoDocument = `
    mutation TriggerAlgo($classeHasModules: Boolean!) {
  triggerAlgo(classeHasModules: $classeHasModules)
}
    `;
export const useTriggerAlgoMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<TriggerAlgoMutation, TError, TriggerAlgoMutationVariables, TContext>) =>
    useMutation<TriggerAlgoMutation, TError, TriggerAlgoMutationVariables, TContext>(
      ['TriggerAlgo'],
      (variables?: TriggerAlgoMutationVariables) => gqlRequest<TriggerAlgoMutation, TriggerAlgoMutationVariables>(TriggerAlgoDocument, variables)(),
      options
    );
export const IsHorsScopeDocument = `
    query IsHorsScope {
  isHorsScope
}
    `;
export const useIsHorsScopeQuery = <
      TData = IsHorsScopeQuery,
      TError = unknown
    >(
      variables?: IsHorsScopeQueryVariables,
      options?: UseQueryOptions<IsHorsScopeQuery, TError, TData>
    ) =>
    useQuery<IsHorsScopeQuery, TError, TData>(
      variables === undefined ? ['IsHorsScope'] : ['IsHorsScope', variables],
      gqlRequest<IsHorsScopeQuery, IsHorsScopeQueryVariables>(IsHorsScopeDocument, variables),
      options
    );
export const useInfiniteIsHorsScopeQuery = <
      TData = IsHorsScopeQuery,
      TError = unknown
    >(
      variables?: IsHorsScopeQueryVariables,
      options?: UseInfiniteQueryOptions<IsHorsScopeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<IsHorsScopeQuery, TError, TData>(
      variables === undefined ? ['IsHorsScope.infinite'] : ['IsHorsScope.infinite', variables],
      (metaData) => gqlRequest<IsHorsScopeQuery, IsHorsScopeQueryVariables>(IsHorsScopeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};
